import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Switch from "@material-ui/core/Switch";
import { parseDate } from "utils/Utils";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import {
  saveAadharTransaction,
} from "store/reducers/LoanApplication/LoanApplicationSlice";
import CorrespondenceAddress from "./CorrespondenceAddress";
import { saveLoanDetails } from "store/reducers/LoanDetail/LoanDetailSlice";
import { saveAadharDetails } from "store/reducers/LoanApplication/LoanApplicationSlice";
import OtpModal from "../OtpModal/OtpModal.js";
import { textFormat } from "utils/Utils.js";
import { Button,Grid, InputLabel, withStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader.js";
import CustomeTextField from "components/UpdateUi/CustomeTextField.js";
import brandTheme from "brandTheme/Theme.js";
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";
import CustomeDateCalender from "components/CustomDateSelector/DateSelector.js";
import { saveLoanApplicantDetails } from "store/reducers/LoanDetail/LoanDetailSlice";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
import { PreFixNameList } from "assets/properties/properties";
import AadharPhotoCaptureModal from "views/admin/components/AadharPhotoCapture/AadharPhotoCaptureModal";
import { aadharVendor } from "assets/properties/properties";
import { parseDob } from "utils/Utils";
import { genderToPrefixMap } from "assets/properties/properties";
import { prefixToGenderMap } from "assets/properties/properties";
import { loanStatusNames } from "assets/properties/properties";
import { documentNamesList } from "assets/properties/properties";
import { headerLabel } from "assets/properties/properties";
import { OccupationListData } from "assets/properties/properties";
import { purposeOfLoanListData } from "assets/properties/properties";
import { GenderListData } from "assets/properties/properties";
import CustomDateField from "components/CustomDateSelector/CustomDateField";
import { panAmountValidate } from "utils/Utils";
import { customerTypeData } from "assets/properties/properties";
import checkNegativeProfileApi from "./CheckNegativeProfileApi";
import ConfirmationModal from "views/components/ConfirmationModal";
import { AADHAAR_DOC_NAMES } from "assets/properties/properties";
import {  BLANK_VALUE } from "assets/properties/properties";
import { maxAge } from "assets/properties/properties";
import { APPLICATION_TYPE_New } from "assets/properties/properties";
import { APPLICATION_SUB_TYPE_PRE_PLEDGE } from "assets/properties/properties";
import { isValidValue } from "utils/Utils";
import { aadharNames } from "assets/properties/properties";
import { minAge } from "assets/properties/properties";
import { statusList } from "assets/properties/properties";
import { isValidPincode } from "assets/properties/properties";
import { isValidateOnlyAlphabets } from "utils/Utils";
import { capitalizeFirstLetter } from "utils/Utils";
import { formatAmount } from "utils/Utils";
const styles = () => ({
 validateButton: { position: "absolute" ,top:0,right:0,padding:'11px 15px', margin:0},
 addressContainer:{display:'flex', alignItems:'center', textAlign:'left', margin:'2% 0 0 1%',"@media (max-width:520px)":{
  flexDirection: "column",marginTop:"20px"
},},
 nextButton:{backgroundColor:brandTheme.buttonColor},
 applicantPageContainer:{
  '& [id="buttonContainer"]':{
    position: 'absolute',
    top: '1%',
    right: '22%',
  }
 }
})
const ApplicantNew = ({
  setBack,
  classes,
  setNext,
  loanApplicationId,
  loanApplicationNumber,
  PanNumberObj,
  editable,
  PanNameObj,
  status,
  onNewCustomer,
  documentLink,
  mobileNum,
  loanAccountNumber,
  panThirdPartyPanEnabled,
  aadharThirdPartyAadharEnabled,
  aadharVendorThirdParty,
  aadharIntegrationOptions,
  featureFlags,
  firstTab,
  enabledFieldsForApplciantPage,
  subStatus,
  applicantDetailsReverifyAadhar,
  actualLoanAmountForProcessingFee,
}) => {
 const dispatch = useDispatch();
  const { aadharDetails, aadharTranaction } = useSelector(
    (state) => state.loanApplication
  );
  const { applicantDetails } = useSelector(
    (state) => state.loanDetail.applicantLoanDetail
  );
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
  const [documentNameList,setDocumentNameList]=useState([]);
  const [maritalStatusList]=useState([
    { code: "Single", name: "Single" },
    { code: "Married", name: "Married" },
  ]);
  const [dateOfBirth, setDateOfBirth] = useState(applicantDetails?.dob);
  const [dateOfBirthState, setDateOfBirthState] = useState("");
  const [isAadharAvailable, setIsAadharAvailable] = useState(true);
const [aadharNumber, setAadharNumber] = useState(
    applicantDetails?.adhaarNumber
  );
  const [aadharNumberState, setAadharNumberState] = useState(false);
  const [loanStatus,setLoanStatus]=useState(false);
  const [purposeOfLoan, setPurposeOfLoan]= useState('');
  const [occupationTypes, setoccupationTypes]= useState('');
  const [tsTransID, setTsTransID] = useState("");
  const [aadhaarPollingLoading, setAadhaarPollingLoading] = useState(false);
  const [aadharVerified, setAadharVerified] = useState(false);
  // const [panNumber, setPanNumber] = useState(PanNumberObj);
  const [aadharApplicantName, setAadharApplicantName] = useState(
    applicantDetails?.nameOnAdhaar || PanNameObj
  );
  const [aadharApplicantNameState, setAadharApplicantNameState] = useState(false);
  const [aadharFatherName, setAadharFatherName] = useState(
    applicantDetails?.fatherName
  );
  const [aadharFatherNameState, setAadharFatherNameState] = useState(false);
  const [email, setEmail] = useState(applicantDetails?.email);
  const [emailState, setEmailState] = useState(false);
  const [documentName, setDocumentName] = useState(
    applicantDetails?.documentName ? applicantDetails?.documentName : ""
  );
  const [documentNameState, setDocumentNameState] = useState(false);
  const [documentNumber, setDocumentNumber] = useState(
    applicantDetails?.documentNumber
  );
  const [documentNumberState, setDocumentNumberState] = useState(false);
  const [maritalStatus, setMateritalStatus] = useState(
    applicantDetails?.maritalStatus ? applicantDetails?.maritalStatus : ""
  );
  const [maritalStatusState, setmaritalStatusState] = useState(false);
  const [motherName, setMotherName] = useState(applicantDetails?.motherName);
  const [motherNameErrorState, setMotherNameErrorState] = useState(false);
  const [spouseName, setSpouseName] = useState(applicantDetails?.spouseName);
  const [spouseNameState, setSpouseNameState] = useState(false);
  const [memberCount, setMemberCount] = useState(applicantDetails?.memberCount);
  const [memeberCountError, setMemberCountError] = useState(false);
  const [annualIncomeState, setAnnualIncomeState] = useState(false);
  const [annualIncome, setAnnualIncome] = useState(
    applicantDetails?.applicantAnnualIncome
  );
  const [houseNumber, setHouseNumber] = useState(
    applicantDetails?.addresses?.[0]?.houseNumber
  );
  const [houseNumberState, setHouseNumberState] = useState(false);
  const [street, setStreet] = useState(
    applicantDetails?.addresses?.[0]?.street
  );
  const [streetState, setStreetState] = useState(false);
  const [locality, setLocality] = useState(
    applicantDetails?.addresses?.[0]?.locality
  );
  const [localityState, setLocalityState] = useState(false);
  const [postOffice, setPostOffice] = useState(
    applicantDetails?.addresses?.[0]?.postOffice
  );
  const [postOfficeState, setPostOfficeState] = useState(false);
  const [villageTownCity, setVillageTownCity] = useState(
    applicantDetails?.addresses?.[0]?.villageTownCity
  );
  const [villageTownCityState, setVillageTownCityState] = useState(false);
  const [stateName, setStateName] = useState(
    applicantDetails?.addresses?.[0]?.state
  );
  const [stateNameState, setStateNameState] = useState(false);
  const [district, setDistrict] = useState(
    applicantDetails?.addresses?.[0]?.district
  );
  const [districtState, setDistrictState] = useState(false);
  const [pincode, setPincode] = useState(
    applicantDetails?.addresses?.[0]?.pincode
  );
  const [pincodeState, setPincodeState] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [mobileNumber, setMobileNumber] = useState(
    applicantDetails?.alternateMobileNumber
  );
  const [mobileNumberState, setMobileNumberState] = useState(false);
  const [processingFee, setProcessingFee] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState("");
  const [emailVerify, setEmailVerify] = useState("");
  const [sameAddress, setSameAddress] = useState(applicantDetails?.sameAddress);
  const correspondancAddress = applicantDetails?.addresses?.[1];
  const [houseCorrNumberState, setHouseCorrNumberState] = useState(false);
  const [streetCorrState, setStreetCorrState] = useState(false);
  const [localityCorrState, setLocalityCorrState] = useState(false);
  const [postOfficeCorrState, setPostOfficeCorrState] = useState(false);
  const [villageTownCityCorrState, setVillageTownCityCorrState] = useState(false);
  const [stateNameCorrState, setStateNameCorrState] = useState(false);
  const [districtCorrState, setDistrictCorrState] = useState(false);
  const [pincodeCorrState, setPincodeCorrState] = useState(false);
  const [stateList, setStateList] = useState([]);
  // const [nameOnPanCard, setNameOnPanCard] = useState(PanNameObj || applicantDetails?.nameOnPanCard);
  const [gstNumber, setGstNumber] = useState(applicantDetails?.gstNumber);
  const [gst, setGst] = useState(applicantDetails?.gstState);
  const [documentDisbale, setDocumentDisable] = useState(false)
  const[coresHouseNumber, setCoresHouseNumber]= useState(correspondancAddress?.houseNumber)
  const[coresStreet, setCoresStreet]= useState(correspondancAddress?.street)
  const[coresLocality, setCoresLocality]= useState(correspondancAddress?.locality)
  const[coresPostOffice, setCoresPostOffice]= useState(correspondancAddress?.postOffice)
  const[coresVillage, setCoresVillage]= useState(correspondancAddress?.villageTownCity)
  const[coresDistrict, setCoresDistrict]= useState(correspondancAddress?.district)
  const[coresPinCode, setCoresPinCode]= useState(correspondancAddress?.pincode)
  const[coresState, setCoresState]=useState(correspondancAddress?.state)
  const [digilance, setDigilance] = useState(false)
  const [digilanceData, setDigilanceData] = useState([])
  const [dueDigilance, setDueDigilance]= useState(false)
  const [digilanceState, setDigilanceState]= useState("")
  const [nameOnPanCardState, setNameOnPanCardState] = useState(false)
  const [gender, setGender]= useState(applicantDetails?.gender || 'Male')
  const [documentExpiryState, setDocumentExpiryState] = useState(false);
  const [documentExpiry, setDocumentExpiry]= useState(applicantDetails?.documentExpiry);
  const [modalrepOpen, setModalReOpen]=useState(false);
  const [showModalForAadhar, setShowModalForAadhar]=useState(false);
  const outletData = featureFlags;
  const GenderList = outletData?.genderList ? JSON.parse(outletData?.genderList) : GenderListData;
  const showProcessingFeeApplicantFlag = parseAndSetFlag(outletData?.showProcessingFeeApplicantFlag);
  const showEmailOnApplicantFlag = parseAndSetFlag(outletData?.showEmailOnApplicantFlag);
  const enabledReKycForDocumentVerification = parseAndSetFlag(outletData?.enabledReKycForDocumentVerification);
  const hideDocumentNameDataFlag = outletData?.hideDocumentNameDataFlag;
  const showPreFixName = parseAndSetFlag(outletData?.showApplicantPreFixName);
  const disabledApplicantLoanDetailsFlag = parseAndSetFlag(outletData?.disabledApplicantLoanDetailsFlag);
  const disbaledAddharFlag = parseAndSetFlag(outletData?.hideSwitchForAadharApplicantPageFlag);
  const validateThirdPartyAttemptsFlag = parseAndSetFlag(outletData?.validateThirdPartyAttemptsFlag);
  const showCustomerType = parseAndSetFlag(outletData?.showCustomerType);
  const enableNegativeProfileCheck = parseAndSetFlag(outletData?.enableCheckNegativeProfile);
  const singlePhtotAdhaarOcr = parseAndSetFlag(outletData?.singlePhtotAdhaarOcr);
  const customerBasedDigiLocker = parseAndSetFlag(outletData?.customerBasedDigilocker);
  const sameDayLoanProcessingFees = parseAndSetFlag(outletData?.sameDayLoanProcessingFees);
  const enabledApplicantFieldsForRootHierarcy = parseAndSetFlag(outletData?.enabledApplicantFieldsForRootHierarcy);
  const enabledManualOcrSelect = parseAndSetFlag(outletData?.enabledManualOcrSelect);
  const enabledCreditAssessmentOnLoanDetails = parseAndSetFlag(outletData?.enabledCreditAssessmentOnLoanDetails);
  const enabledAddressDetailsValidate = parseAndSetFlag(outletData?.enabledAddressDetailsValidate);
  const enabledUploadForm60Options = parseAndSetFlag(outletData?.enabledUploadForm60Options);
  const loanAmountForFrom60 = Number(outletData?.loanAmountForFrom60);
  const maxAgeForDateOfBirth = Number(outletData?.maxAgeForDateOfBirth) || maxAge;
  const minAgeForDateOfBirth = Number(outletData?.minAgeForDateOfBirth) || minAge;
  const PurposeOfLoan = outletData?.purposeOfLoanFlag ? JSON.parse(outletData?.purposeOfLoanFlag) : purposeOfLoanListData;
  const OccupationList = outletData?.occupationListFlag ? JSON.parse(outletData?.occupationListFlag) : OccupationListData;
  const annualIncomeAmount = outletData?.annualIncomeFlag;
  const [applicantDetailAgainstId, setApplicantDetailAgainstId] = useState(false);
  const [disabledFields, setDisabledFields] = useState(false);
  const [prefixName, setPreFixName] = useState("Mr");
  const [prefixNameState, setPreFixNameState] = useState(false);
  const [panApplicantName, setPanApplicantName] = useState("");
  const [panApplicantNumber, setPanApplicantNumber] = useState("");
  const [panApplicantNumberState, setPanApplicantNumberState] = useState(false);
  const [totalAmountPerYear, setTotalLoanAmountPerYear] = useState(0);
  const [actualLoanAmount, setActualLoanAmount] = useState("");
  const [panVerified, setPanVerified] = useState(false);
  const [panNumberDisabled, setPanNumberDIsabled] = useState(false);
  const [panVerifiedName, setPanVerifiedName] = useState(true);
  const PANCRITERIA = Number(outletData?.panThreshHoldFlag);
  const YEARLYPANCRITERIA = Number(outletData?.panThreshHoldYearlyFlag);
  const checkActualLoanAmountPerYear = parseAndSetFlag(outletData.checkTotalLoanAmountInYear);
  const iflActualLoanAmount = Number(totalAmountPerYear) + Number(actualLoanAmount);
  const [customerId, setCustomerId] = useState("")
  const [panValidate,setPanValidated]=useState(true);
  const [aadharIntegrationName, setAadharIntegrationName] = useState(aadharIntegrationOptions?.[0]?.code || "");
  const [showAadharCaptureModal, setShowAadharCaptureModal] = useState(false);
  const [hideVendorName,setHideVendorName] = useState(false);
  const [aadharOtpModal, setAadharOtpModal] = useState(false)
  const [customerType, setCustomerType]=useState(customerTypeData[0]?.code);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [confirmationModalDigiloker, setConfirmationModalDigiloker] = useState(false);
  const [confirmationModalHeaderDigiloker, setConfirmationModalHeaderDigiloker] = useState("");
  const [confirmationModalMsgDigiloker, setConfirmationModalMsgDigiloker] = useState("");
  const [digilokerSignUpUrl, setDigilokerSignUpUrl] = useState("");
  const [riskPresent,setRiskPresent] = useState(false);
  const [negativePresent,setNegativePresent] = useState(false);
  const [aadharIntegrationVerified,setAadharIntegrationVerified] = useState(true);
  const [enabledSendToHOButton,setEnabledSendToHOButton] = useState(false);
  const [isKYCEntered,setISKYCEntered] = useState(false);
  const [isCustomerInit,setIsCustomerInit] = useState(false);
  const [isKYCReliazed,setIsKYCReliazed] = useState(true);
  const [enabledKYCFields,setEnabledKYCFields] = useState(applicantDetailsReverifyAadhar);
  const enableFamilyDetailsTab = parseAndSetFlag(featureFlags?.creditAssessment);
  const enableCreditAssesmentOnBtCases = subStatus !== APPLICATION_SUB_TYPE_PRE_PLEDGE || (parseAndSetFlag(featureFlags?.enabledCreditAssesmentInBtPrePledge) && subStatus === APPLICATION_SUB_TYPE_PRE_PLEDGE)
  const [addressDetailsAvailable, setAddressDetailsAvailable] = useState({
    fatherNameState: false,
    houseState: false,
    streetState: false,
    localityState: false,
    postOfficeState: false,
    villageState: false,
    state: false,
    districtState: false,
    pincodeState: false,
    dob: false,
    genderState: false,
  });
  const [emailValidationAttempted, setEmailValidationAttempted] = useState({
    success: false,
    error: false,
  });
  const [panValidationAttempted, setPanValidationAttempted] = useState({
    success: false,
    error: false,
  });
  const [aadharValidationAttempted, setAadharValidationAttempted] = useState({
    success: false,
    error: false,
  });
  const setyear = (year) => {
    var date = new Date();
    date.setFullYear(date.getFullYear() - year);
    return date; //# => Thu Mar 31 2011 11:14:50 GMT+0200 (CEST)
  };
   const storageKey = "ongridDigiLockerData";
    const existingData = JSON?.parse(
      sessionStorage?.getItem(storageKey) || "[]"
    );
    const existingIndex = existingData.findIndex(
      (item) => item?.loanApplicationId === loanApplicationId
    );
    const clearSessionStorage = () => {
      const updatedData = existingData.filter(
          (item) => item?.loanApplicationId !== loanApplicationId
        );
        sessionStorage?.setItem(
          storageKey,
          JSON?.stringify(updatedData)
        );
    }
  const handleDateChange = (date) => {
    setDateOfBirth(date);
  };
  const handleDocumentExpiry = (date) => {
    setDocumentExpiry(date);
    setDocumentExpiryState(false);
  };
  useEffect(()=>{
    if(aadharIntegrationName === "MANUAL"){
      setIsAadharAvailable(false);
    }
  },[aadharIntegrationName])
  useEffect(() => {
      getAllDocumentNames();
      if (showProcessingFeeApplicantFlag) {
        getLoanProcessingFee();
      }
      if(applicantDetailsReverifyAadhar){
        setDocumentName("AADHAR_CARD");
        searchAadharDetails();
      }
  }, [status,showProcessingFeeApplicantFlag]);
  useEffect(() => {
    if (existingIndex !== -1 && existingData?.[existingIndex] && !aadharDetails?.adhaarNumber) {
      const storedTimestamp = existingData[existingIndex].timestamp;
      const isWithin90Seconds =
        storedTimestamp + 90 * 1000 >= Date.now();
      if (isWithin90Seconds) {
        setCallInProgress(true);
      } else {
        console.log("in 90 seconds welse",storedTimestamp + 90 * 1000,Date.now())
        setCallInProgress(false);
        setEnabledSendToHOButton(true);
      }
    }
  }, [existingIndex, existingData, aadharDetails]);
  const getAllDocumentNames = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_ALL_DOCUMENT_NAMES,
      authToken: authToken,
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const filteredData = result?.data?.filter(
        (item) => !hideDocumentNameDataFlag?.includes(item.displayName)
      );
      setDocumentNameList(filteredData);
      getStateData();
    }
  };
  const getStateData = async () => {
    const result = await apiHandler({
      url: endpoint.MASTER_STATE_FINDALL,
      authToken: authToken,
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      result?.data?.sort((a, b) => a.name.localeCompare(b.name));
      setStateList(result.data);
    }
    if(!editable && status !== loanStatusNames?.inProcess && status !== loanStatusNames?.aadhaar){
      GetApplicantDetails()
    }else{
      if(firstTab){
        if (status === loanStatusNames?.inProcess || status === loanStatusNames?.aadhaar || editable) {
          getDigilanceData();
        }
      }else{
        if((subStatus === "PRE_PLEDGE" && applicantDetailsReverifyAadhar) && (status === loanStatusNames?.inProcess || status === loanStatusNames?.aadhaar || editable)){
          getDigilanceData();
        }else{
          GetLoanOrnamentDetails();
        }
      }
    }
  };
  const GetLoanOrnamentDetails = async () => {
    const result = await apiHandler({
      url: endpoint.ORNAMENT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    if (result?.data?.error_code === 400) {
      toastUpdate("Error", result?.data?.user_description, true);
      return;
    } else if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setActualLoanAmount(result?.data?.actualLoanAmount);
      dispatch(
        saveLoanDetails({
          ornamentDetail: result.data,
        })
      );
      if (status === loanStatusNames?.inProcess || status === loanStatusNames?.aadhaar || editable) {
        getDigilanceData();
      }
    }
  };
  useEffect(() => {
     if(aadharIntegrationOptions?.length && documentName === documentNamesList?.aadhaar){
      setAadharIntegrationName(aadharIntegrationOptions[0]?.code || "");
    }
  },[aadharIntegrationOptions])

  const getDigilanceData = async () => {
    const result = await apiHandler({
      url: endpoint.FIND_DIGILLANCE,
      authToken: authToken,
    });
    if (result?.data) {
      setDigilanceData(result?.data);
    }
    getLoanDetails();
  };
  const getLoanDetails = async () => {
    // Get Loan Application Details
    const result = await apiHandler({
      url: endpoint.CUSTOMER_APPLICATIONFINDID + loanApplicationId,
      authToken: authToken,
    });
    if (result?.data?.email) {
      setEmailValidationAttempted({ success: true });
      setEmail(result?.data?.email);
      setEmailVerify("success");
    }
    GetApplicantDetails();
  };
  const getLoanProcessingFee = async () => {
     const requestOptions = {
        url: endpoint.DISBURSAL_SCHEME_CHARGES + loanApplicationId,
        authToken: authToken,
        method:"POST"
      };
      requestOptions.data = {};
      if (sameDayLoanProcessingFees && Number(actualLoanAmountForProcessingFee) > 0 ) {
        requestOptions.data.loanAmountForProcessFee = actualLoanAmountForProcessingFee;
      }
      const result = await apiHandler(requestOptions);
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      result?.data?.schemeCalculations?.forEach((item) => {
        if (item.chargeType === "PROCESSING_FEE") {
          setProcessingFee(item?.adjustedAmount);
        }
      });
    }
  };
  useEffect(() => {
    if (documentName !== documentNamesList?.passport && documentName !== documentNamesList?.drivingLicense) {
      setDocumentExpiry("");
    }
  }, [documentName]);

  const adharNumberSplit = aadharTranaction.aadharNumber?.slice(-4) === aadharDetails?.adhaarNumber?.slice(-4);
  useEffect(() => {
      if (adharNumberSplit && aadharDetails?.adhaarNumber && aadharNumber && isAadharAvailable) {
         toastUpdate("Information", "Aadhar number is matched", true);
         clearSessionStorage();
         setAadharIntegrationVerified(false);
       }
    if (!adharNumberSplit && aadharDetails?.adhaarNumber  && isAadharAvailable) {
      toastUpdate("Error", "Aadhar not matched", true);
    }
  }, [aadharDetails && typeof aadharDetails?.adhaarNumber !== "undefined", aadharNumber]);
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const handleClose = () => {
    setModalReOpen(false);
    setShowModalForAadhar(false);
    setShowModal(false);
    setEmailState(true);
    setEmailVerify("error");
  };
  const handleAadharModalClose = () =>{
    setAadharOtpModal(false)
  }
  const checkedAddress = (e) => {
    if (e.target.checked) {
      setSameAddress(true);
    } else {
      setSameAddress(false);
    }
  };
  useEffect(() => {
    if (applicantDetails?.email && email) {
      setEmailVerify("success");
      setEmailState(false);
    }
  }, [applicantDetails?.email]);
  useEffect(() => {
    if (status === loanStatusNames?.aadhaar && adharNumberSplit) {
      updateRecords(aadharTranaction, aadharDetails, aadharTranaction?.aadharIntegrationName);
    }
  }, [status]);
  useEffect(() => {
    if (stateList && stateList.length && aadharDetails && aadharDetails.state) {
      let sl = stateList.filter(
        (s) => s.name.toLowerCase() === aadharDetails.state.toLowerCase()
      );
      if (sl.length > 0) {
        setStateName(sl[0].name);
      }
    }
  }, [stateList, aadharDetails]);
  const updateRecords = async (transactionId, aadharData, vendor ) => {
    if (transactionId && transactionId.aadharNumber) {
      setAadharNumber(transactionId.aadharNumber);
      setAadharNumberState(false);
      setIsAadharAvailable(transactionId?.isAadharAvailable);
    }
    if (aadharData && aadharData.name) {
      setDocumentDisable(true);
      if (disbaledAddharFlag) {
        if (transactionId && transactionId.aadharNumber) {
          setDocumentNumber(transactionId.aadharNumber);
          setDocumentName(documentNamesList?.aadhaar);
        }
      }
      const pincodeTrim = aadharData?.pincode?.trim();
      const isPincode = isValidPincode(pincodeTrim);
      const postOffice = aadharData?.postOffice?.trim();
      const isPostOffice = isValidateOnlyAlphabets(postOffice, enabledAddressDetailsValidate);
      const villageTownCity = aadharData?.villageTownCity?.trim();
      const isVillageTownCity = isValidateOnlyAlphabets(villageTownCity, enabledAddressDetailsValidate);
      const district = aadharData?.district?.trim();
      const isDistrict = isValidateOnlyAlphabets(district, enabledAddressDetailsValidate);
      setAddressDetailsAvailable({
        fatherNameState: !!aadharData?.fatherName?.trim(),
        houseState: !!aadharData?.houseNumber?.trim(),
        streetState: !!aadharData?.street?.trim(),
        localityState: !!aadharData?.locality?.trim(),
        postOfficeState: isPostOffice,
        villageState: isVillageTownCity,
        state: !!aadharData?.state?.trim(),
        districtState: isDistrict,
        pincodeState: isPincode,
        dob: !!aadharData?.dob?.trim(),
        genderState: !!aadharData?.gender?.trim(),
      });
      if (
          applicantDetailsReverifyAadhar &&
          (
            !aadharData?.name ||
            !aadharData?.dob || 
            !aadharData?.postOffice || 
            !aadharData?.pincode || 
            !aadharData?.district 
          )
        ) {
          setEnabledSendToHOButton(true);
          toastUpdate("Error", "Aadhar is not authenticated successfully please verify with HO");
          setISKYCEntered(true);
          return;
        }
      if (isDistrict) {
        setDistrict(textFormat(aadharData.district));
        setDistrictState(false);
      }
      if (aadharData.dob) {
        const rawDob = aadharData?.dob;
        const parsedDob = parseDob(rawDob);
        if (parsedDob) {
          setDateOfBirth(parsedDob);
          setDateOfBirthState(false);
        }
      }
      if (aadharData.fatherName) {
        setAadharFatherName(textFormat(aadharData.fatherName));
        setAadharFatherNameState(false);
      }
        setAadharIntegrationName(vendor);
      if (aadharData.houseNumber) {
        setHouseNumber(aadharData.houseNumber);
        setHouseNumberState(false);
      }
      if (aadharData.locality) {
        setLocality(aadharData.locality);
        setLocalityState(false);
      }
      if (aadharData.name) {
        setAadharApplicantName(textFormat(aadharData.name));
        setAadharApplicantNameState(false);
      }
      if (isPostOffice) {
        setPostOffice(aadharData.postOffice);
        setPostOfficeState(false);
      }
      if (aadharData.street) {
        setStreet(aadharData.street);
        setStreetState(false);
      }
      if (isVillageTownCity) {
        setVillageTownCity(textFormat(aadharData.villageTownCity));
        setVillageTownCityState(false);
      }
      if (aadharData.state) {
        setStateName(aadharData.state);
        // setStateNameState(false);
      }
      if (isPincode) {
        setPincode(aadharData?.pincode);
        setPincodeState(false);
      }
      if (aadharData.gender) {
        setGenderDetails(aadharData.gender);
      }
      if (aadharData.name && aadharData.name !== "") {
        setIsAadharAvailable(true);
        setAadharVerified(true);
        setAadharValidationAttempted({ success: true });
      } else {
        setIsAadharAvailable(false);
        setAadharVerified(false);
        setAadharValidationAttempted({ error: true });
      }
     if(vendor === aadharVendor?.ongridDigiLocker && !!aadharData?.adhaarPhotoLink){
            setCallInProgress(true);
            const res = await apiHandler({
              url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
              method: "POST",
              authToken: authToken,
              data: {
                loanApplicationId: loanApplicationId,
                kycDocumentLink: aadharData?.adhaarPhotoLink?.trim(),
              },
            });
            setCallInProgress(false);
        }
      
    }
  };
  const setGenderDetails = (aadharGender) => {
    switch (aadharGender?.toLowerCase()) {
      case "m":
      case "male":
        setGender(GenderList[0]);
        break;

      case "f":
      case "female":
        setGender(GenderList[1]);
        break;

      default:
        setGender(GenderList[2]);
        break;
    }
  };

  const GetApplicantDetails = async () => {
  // setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.APPLICANT_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data !== "" && Object.keys(result?.data)?.length > 0) {
      if (status !== loanStatusNames?.inProcess && status !== loanStatusNames?.aadhaar) {
        setAddressDetailsAvailable({
          fatherNameState: true,
          houseState: true,
          streetState: true,
          localityState: true,
          postOfficeState: true,
          villageState: true,
          state: true,
          districtState: true,
          pincodeState: true,
          dob: true,
          genderState: true,
        });
      }
      setApplicantDetailAgainstId(true);
      setPanApplicantNumber(result?.data?.panNumber || PanNumberObj);
      setPanNumberDIsabled(result?.data?.panNumber || PanNumberObj)
      setPanApplicantName(result?.data?.nameOnPanCard || PanNameObj)
      if((result?.data?.panNumber || PanNumberObj) && (result?.data?.nameOnPanCard || PanNameObj)){
        setPanVerified(true);
      }
      if (result?.data?.adhaarAvailable) {
        setAadharValidationAttempted({ success: true });
      }
      if (result?.data?.panVerified) {
        setPanValidationAttempted({ success: true });
      }
      if (result?.data?.panNumber && !result?.data?.panVerified) {
        setPanValidationAttempted({ error: true });
      }
      setIsAadharAvailable(result?.data?.adhaarAvailable);
      const name = result?.data?.documentName?.toLowerCase();
        let documentNameUpdate = ""
        if(name === "adhaar card" || name === "aadhar card" || name === "aadhar_card" || name === "adhar_card"){
          documentNameUpdate= documentNamesList?.aadhaar;
        }else if(name === "voter id" || name === "voter_id" || name === documentNamesList?.voterId || name === "VOTER ID"){
          documentNameUpdate= documentNamesList?.voterId
        }else if(name === "passport"){
          documentNameUpdate= documentNamesList?.passport
        }else if(name === "other"){
          documentNameUpdate= documentNamesList?.otherDocuments
        }else{
          documentNameUpdate=result?.data?.documentName
        }
        if(documentNameUpdate){
          setDocumentName(documentNameUpdate)
        }
     if(!result?.data?.adhaarAvailable && (result?.data?.adhaarNumber || result?.data?.documentNumber )&& documentNameUpdate === documentNamesList?.aadhaar){
        setAadharValidationAttempted({error:true});
        }
      if(result?.data?.adhaarAvailable){
        setAadharNumber(result?.data?.adhaarNumber?.replace(/\s+/g, ''));
        setDocumentNumber(result?.data?.adhaarNumber?.replace(/\s+/g, ''));
        setAadharIntegrationName(result?.data?.aadhaarVendor);
        if(!result?.data?.aadhaarVendor && typeof result?.data?.aadhaarVendor === "undefined" && result.data?.aadhaarVendor === null){
          setHideVendorName(true);
        }
        if (disbaledAddharFlag) {
          setDocumentName(documentNamesList?.aadhaar);
        }
      } else {
        setDocumentNumber(result?.data?.documentNumber);
      }
      if (result?.data?.nameOnAdhaar) {
        setAadharApplicantName(result?.data?.nameOnAdhaar);
      } else {
        setAadharApplicantName(result?.data?.nameOnPanCard || PanNameObj);
      }
      setAadharFatherName(result?.data?.fatherName);
      setDateOfBirth(result?.data?.dob);
      setEmail(result?.data?.email);
      if (result?.data?.email) {
        setEmailValidationAttempted({ success: true });
      }
      setAadharIntegrationVerified(false);
      setNegativePresent(result?.data?.customerRisk)
      setMobileNumber(result?.data?.alternateMobileNumber?.trim());
      setGstNumber(result?.data?.gstNumber);
      setGst(result?.data?.gstState);
      setSameAddress(result?.data?.sameAddress);
      setHouseNumber(result?.data?.addresses?.[0]?.houseNumber);
      setStreet(result?.data?.addresses?.[0]?.street);
      setLocality(result?.data?.addresses?.[0]?.locality);
      if(result?.data?.addresses?.[0]?.pincode){
        setPincode(result?.data?.addresses?.[0]?.pincode);
      }
      if(result?.data?.addresses?.[0]?.postOffice){
        setPostOffice(result?.data?.addresses?.[0]?.postOffice);
      }
      setDistrict(result?.data?.addresses?.[0]?.district);
      if(result?.data?.addresses?.[0]?.villageTownCity){
        setVillageTownCity(result?.data?.addresses?.[0]?.villageTownCity);
      }
      setStateName(result?.data?.addresses?.[0]?.state);
       setCustomerType(result?.data?.customerType)
      if (result?.data?.occupationType) {
        if (OccupationList?.includes(result?.data?.occupationType)) {
          setoccupationTypes(result?.data?.occupationType);
        } else {
          setoccupationTypes(OccupationList?.[0]);
        }
      }
      if (result?.data?.purposeOfLoan) {
        if (PurposeOfLoan?.includes(result?.data?.purposeOfLoan)) {
          setPurposeOfLoan(result?.data?.purposeOfLoan);
        } else {
          setPurposeOfLoan(PurposeOfLoan?.[0]);
        }
      }
      setGender(result?.data?.gender);
      setMotherName((result.data && result?.data?.motherName) || "");
      setPreFixName(result?.data?.applicantNamePrefix);
      setDocumentExpiry(result?.data?.documentExpiry || "");
      if (result?.data?.dueDiligence) {
        setDigilance(true);
        setDigilanceState(result?.data?.dueDiligence || "");
      }
      setMateritalStatus((result.data && result?.data?.maritalStatus) || "");
      setAnnualIncome(
        (result.data && result?.data?.applicantAnnualIncome) || "0"
      );
      setMemberCount(result.data && result?.data?.memberCount);
      setSpouseName((result.data && result?.data?.spouseName) || "");
      const correspondingData = result?.data?.addresses?.filter(
        (item) =>
          item.addressType === "RESIDENTIAL_ADDRESS" ||
          item?.addressType === "CORRESPONDENCE_ADDRESS"
      );
      setCoresHouseNumber(correspondingData[0]?.houseNumber);
      setCoresDistrict(correspondingData[0]?.district);
      setCoresLocality(correspondingData[0]?.locality);
      setCoresPinCode(correspondingData[0]?.pincode);
      setCoresPostOffice(correspondingData[0]?.postOffice);
      setCoresState(correspondingData[0]?.state);
      setCoresStreet(correspondingData[0]?.street);
      setCoresVillage(correspondingData[0]?.villageTownCity);
      if (disabledApplicantLoanDetailsFlag && status === loanStatusNames?.inProcess) {
        setCallInProgress(true);
        const searchQueryParams =
          result?.data?.documentNumber || result?.data?.adhaarNumber;
        const res = await apiHandler({
          url: endpoint.SEARCH_PROFILE + searchQueryParams,
          authToken: authToken,
        });
        setCallInProgress(false);
        if (res?.data?.length === 1 && mobileNum === res?.data?.[0]?.communication?.primarymobileNumber) {
          setDisabledFields(true);
          setAadharIntegrationVerified(false);
        }
      }
    } else {
        setApplicantDetailAgainstId(false);
        if(status !== loanStatusNames?.aadhaar || (enabledReKycForDocumentVerification && subStatus !== "NEW" && !adharNumberSplit)) {
          setIsAadharAvailable(false);
          SearchProfileData();
          if(customerBasedDigiLocker){
            const storedData =
              JSON.parse(sessionStorage.getItem("loanApplicationData")) || [];
            const matchedLoan = storedData.find(
              item => item.loanApplicationId === loanApplicationId
            );
              await checkAadharDetails(false ,true, matchedLoan?.vendorName);
          }
        }
    }
  };
  const getTotalLoanAmount = async (custId) => {
    const result = await apiHandler({
      url: endpoint.TOTAL_LOAN_IN_YEAR + custId + "/total-loan",
      authToken: authToken,
    });
    if (!result?.data?.error_code) {
      setTotalLoanAmountPerYear(result?.data?.totalLoanTaken);
    }
  };
  const ocrVendor = singlePhtotAdhaarOcr ? aadharVendor?.smcAuthBridgeOCR : aadharVendor?.authBridgeOCR
  const GetPRofile = async (result) => {
    const panArray = result?.identification?.filter((item)=> item?.identificationType?.toLowerCase() === "pan");
    const documentArray = result?.identification?.filter((item) => item?.identificationType?.toUpperCase() !== "PAN");
    const name = documentArray?.[0]?.documentName?.toLowerCase();
    let documentName = "";
    if (["adhaar card", "aadhar card", "aadhar_card", "adhar_card"]?.includes(name) ) {
      documentName = documentNamesList?.aadhaar;
    } else if (["voter id", "voter_id", documentNamesList?.voterId, "VOTER ID"]?.includes(name)) {
      documentName = documentNamesList?.voterId;
    } else if (name === "passport") {
      documentName = documentNamesList?.passport;
    } else if (name === "other") {
      documentName = documentNamesList?.otherDocuments;
    } else {
      documentName = documentArray?.[0]?.documentName;
    }
    if(panArray?.length > 0){
    panArray?.[0]?.verified
  ? setPanValidationAttempted({ success: true })
  : setPanValidationAttempted({ error: true });
    }
    setPanVerified(panArray?.[0]?.verified);
  if (result?.adharNumber !== undefined && result?.adharNumber !== null) {
    setAadharIntegrationName(documentArray?.[0]?.vendor || ocrVendor);
    setAadharNumber(result?.adharNumber)
    setDocumentDisable(true);
    setIsAadharAvailable(true);
    setAadharIntegrationName(documentArray?.[0]?.vendor ? documentArray?.[0]?.vendor : aadharVendor?.authBridgeOCR)
    if (documentArray?.[0]?.verified) {
      setAadharValidationAttempted({ success: true });
    } else {
      setAadharValidationAttempted({ error: true });
    }
    if(disbaledAddharFlag){
      setDocumentName(documentName);
      setDocumentNumber(documentArray?.[0]?.identificationNum);
    }
  }else{
    if (documentArray?.length > 0) {
    setDocumentName(documentName);
    setDocumentNumber(documentArray?.[0]?.identificationNum);
    setDocumentDisable(true);
  }
  }

result?.applicantName ? onNewCustomer(false) : onNewCustomer(true);
documentLink(result?.documentLinks);

if (result?.communication?.primaryEmail) {
  setEmailState(false);
  setEmailVerify("success");
  setEmailState(false);
}

setEmail(result?.communication?.primaryEmail || "");


setAadharApplicantName(textFormat(result?.applicantName || ""));
setDateOfBirth(result?.dateOfBirth ? new Date(result.dateOfBirth) : "");

if ((result?.panNumber || PanNumberObj) && (result?.nameOnPanCard || PanNameObj)) {
  setPanApplicantName(result?.nameOnPanCard || PanNameObj);
  setPanApplicantNumber(result?.panNumber || PanNumberObj);
  setPanNumberDIsabled(result?.panNumber || PanNumberObj);
  setPanVerified(true);
}

setDocumentExpiry(result?.documentExpiry || documentArray?.[0]?.documentExpiry);
if (result?.applicantName) setAadharApplicantNameState(false);
if (result?.dateOfBirth) setDateOfBirthState(false);

setAadharFatherName(result?.fatherName || "");

if (result?.occupationType) {
  setoccupationTypes(
    OccupationList?.includes(result.occupationType)
      ? result.occupationType
      : OccupationList?.[0]
  );
}

if (result?.purposeOfLoan) {
  setPurposeOfLoan(
    PurposeOfLoan?.includes(result.purposeOfLoan)
      ? result.purposeOfLoan
      : PurposeOfLoan?.[0]
  );
}

if (result?.fatherName) setAadharFatherNameState(false);

setHouseNumber(textFormat(result?.address?.[0]?.fullAddress?.houseNo) || "");
if (result?.address?.[0]?.fullAddress?.houseNo) setHouseNumberState(false);

setStreet(result?.address?.[0]?.fullAddress?.street || "");
if (result?.address?.[0]?.fullAddress?.street) setStreetState(false);

setLocality(result?.address?.[0]?.fullAddress?.locality || "");
if (result?.address?.[0]?.fullAddress?.locality) setLocalityState(false);
if(isValidateOnlyAlphabets(result?.address?.[0]?.fullAddress?.postOffice, enabledAddressDetailsValidate)){
setPostOffice(result?.address?.[0]?.fullAddress?.postOffice || "");
if (result?.address?.[0]?.fullAddress?.postOffice) setPostOfficeState(false);}
if(isValidateOnlyAlphabets(result?.address?.[0]?.fullAddress?.city, enabledAddressDetailsValidate)){
setVillageTownCity(textFormat(result?.address?.[0]?.fullAddress?.city) || "");
if (result?.address?.[0]?.fullAddress?.city) setVillageTownCityState(false);}

setStateName(textFormat(result?.address?.[0]?.fullAddress?.state) || "");
if (result?.address?.[0]?.fullAddress?.state) setStateNameState(false);
if(isValidateOnlyAlphabets(result?.address?.[0]?.fullAddress?.district, enabledAddressDetailsValidate)){
setDistrict(textFormat(result?.address?.[0]?.fullAddress?.district) || "");
}
if (result?.address?.[0]?.fullAddress?.district) setDistrictState(false);
if(isValidPincode(result?.address?.[0]?.fullAddress?.pincode)){
setPincode(result?.address?.[0]?.fullAddress?.pincode || "");
if (result?.address?.[0]?.fullAddress?.pincode) setPincodeState(false);
}
setMobileNumber(result?.communication?.alternateMobileNumber?.trim() || "");
if (result?.communication?.alternateMobileNumber?.length === 10) setMobileNumberState(false);

if (result?.dueDiligence) {
  setDigilance(true);
  setDigilanceState(result?.data?.dueDiligence || "");
}

setMotherName(result?.motherName);
setPreFixName(result?.applicantNamePrefix || "Mr");
setMateritalStatus(result?.maritalStatus);
setAnnualIncome(result?.applicantAnnualIncome || "0");
setMemberCount(result?.memberCount);
setSpouseName(result?.spouseName);
setGender(result?.gender || "Male");

// Correspondence address
setCoresHouseNumber(textFormat(result?.address?.[1]?.fullAddress?.houseNo) || "");
if (result?.address?.[1]?.fullAddress?.houseNo) setHouseCorrNumberState(false);

setCoresStreet(result?.address?.[1]?.fullAddress?.street || "");
if (result?.address?.[1]?.fullAddress?.street) setStreetCorrState(false);

setCoresLocality(result?.address?.[1]?.fullAddress?.locality || "");
if (result?.address?.[1]?.fullAddress?.locality) setLocalityCorrState(false);
setCoresPostOffice(result?.address?.[1]?.fullAddress?.postOffice || "");
if (result?.address?.[1]?.fullAddress?.postOffice) setPostOfficeCorrState(false);
setCoresVillage(textFormat(result?.address?.[1]?.fullAddress?.city) || "");
if (result?.address?.[1]?.fullAddress?.city) setVillageTownCityCorrState(false);
setCoresState(textFormat(result?.address?.[1]?.fullAddress?.state) || "");
if (result?.address?.[1]?.fullAddress?.state) setStateNameCorrState(false);
setCoresDistrict(textFormat(result?.address?.[1]?.fullAddress?.district) || "");
if (result?.address?.[1]?.fullAddress?.district) setDistrictCorrState(false);
setCoresPinCode(result?.address?.[1]?.fullAddress?.pincode || "");
if (result?.address?.[1]?.fullAddress?.pincode) setPincodeCorrState(false);
}
const verifyPAN = async () => {
  setCallInProgress(true);

  const response = await apiHandler({
    url: endpoint.NEW_PAN_CARD_VERIFY,
    authToken: authToken,
    method: "POST",
    data: {
      panNumber: panApplicantNumber?.toUpperCase(),
      dob: parseDate(dateOfBirth),
      name: aadharApplicantName,
    },
  });

  setCallInProgress(false);

  if (
    (response?.data?.error_code ||
      response?.data?.name?.trim() === "" ||
      !response?.data ||
      response?.data?.name === null ||
      !response) &&
    !panThirdPartyPanEnabled
  ) {
    setPanVerified(true);
    setPanVerifiedName(false);
    setPanValidationAttempted({ success: true });
  } else if (response?.data?.error_code) {
    setPanApplicantNumber("");
    setPanApplicantNumberState(true);
    setPanValidated(false);
    setPanVerified(false);
    setPanVerifiedName(true);
    toastUpdate("Error", response?.data?.user_description, true);
    setPanValidationAttempted({ error: true });
    return;
  } else if (response?.data?.name?.trim() === "") {
    setPanVerified(false);
    setPanValidated(true);
    setPanVerifiedName(true);
    setPanValidationAttempted({ error: true });
  } else {
    setPanApplicantName(response?.data?.name);
    setPanApplicantNumber(response?.data?.panCard);
    setPanValidated(true);
    setPanVerified(true);
    setPanVerifiedName(true);
    setPanApplicantNumberState(false);
    setPanValidationAttempted({ success: true });
  }
};

  const SearchProfileData = async (value, blured) => {
    if(blured && enableNegativeProfileCheck){
      const panValue = blured === "PAN" ? true : false;
      const apiReponse = await checkNegativeProfileApi(apiHandler,
      endpoint,
      authToken,
      setCallInProgress,
      toastUpdate,
      !panValue ? value : null,
      panValue ? value : null,)
      if (apiReponse?.[0]?.risk) {
       setNegativePresent(apiReponse?.[0]?.risk)
        proceedApplication();
      }
    }
    setCallInProgress(true);
    let queryParams = "";
    if (aadharNumber && blured === "PAN") {
      queryParams = `${mobileNum?.trim()},${aadharNumber?.trim()},${value?.toUpperCase()?.trim()}`;
    } else if (documentNumber && blured === "PAN") {
      queryParams = `${mobileNum?.trim()},${documentNumber?.trim()},${value?.toUpperCase()?.trim()}`;
    } else if (value) {
      queryParams = `${mobileNum?.trim()},${value?.trim()}`;
    } else {
      queryParams = `${mobileNum?.trim()}`;
    }
    const errorMessage = "Document Number is Linked with other customer";
    const errorMessgae1 = blured === "PAN" ? "Pan is Linked with other customer" : errorMessage;
    const res = await apiHandler({
      url: endpoint.SEARCH_PROFILE + queryParams,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.length > 1) {
      const customerIds = res?.data?.map(item => item?.customerId)?.filter(Boolean)?.join(", ");
      toastUpdate("Error", `${errorMessgae1} Customer IDs: ${customerIds}`, true);
      setLoanStatus(true);
    } else if (res?.data?.length === 1) {
            setAadharIntegrationVerified(false);
      if (blured === "aadharBlur") {
        setAadharNumber("");
        setIsAadharAvailable(false);
      }
      if (status === loanStatusNames?.inProcess && res?.data?.[0]?.customerId && checkActualLoanAmountPerYear) {
        getTotalLoanAmount(res?.data?.[0]?.customerId);
      }
      if (mobileNum !== res?.data?.[0]?.communication?.primarymobileNumber) {
        toastUpdate("Error", errorMessgae1, true);
        setLoanStatus(true);
      } else {
        if (blured === "PAN") {
          setLoanStatus(false);
          verifyPAN();
        } else {
          let allApplicantLoan = []
          if(applicantDetailsReverifyAadhar){
              setCallInProgress(true);
                const res = await apiHandler({
                    url: endpoint.GET_ALL_DATA_MOBILE_NUMBER,
                    authToken: authToken,
                    method:"POST",
                    data: {
                      mobileNumber: mobileNum,
                      source: "WEB",
                      renewalFlag: false,
                      toupFlag:false,
                    }
                  });
              setCallInProgress(false);
              allApplicantLoan = res?.data
            }
            const documentArray = res?.data?.[0]?.identification?.filter((item) => item?.identificationType?.toUpperCase() !== documentNamesList?.pan);
            const shouldRender = documentArray.some(doc => aadharNames.includes(doc.documentName.toLowerCase()) && doc.verified) && allApplicantLoan?.length > 0;
          if(res?.data?.[0]){       
            if(!applicantDetailsReverifyAadhar || (shouldRender && applicantDetailsReverifyAadhar)){
              GetPRofile(res?.data?.[0]);
            }
          }
          if (applicantDetailsReverifyAadhar && !shouldRender) {
            const aadharDoc = res?.data?.[0]?.identification?.find((item) => {
              const docName = item?.documentName
                ?.trim()
                ?.replace(/_/g, " ")
                ?.toUpperCase();
              return (
                item?.identificationType?.toUpperCase() !== "PAN" &&
                AADHAAR_DOC_NAMES.includes(docName)
              );
            });
            if (aadharDoc && value?.trim() !== aadharDoc?.identificationNum?.trim() && isValidValue(value)) {
              toastUpdate("Error",`Entered Aadhar number does not match linked Aadhar ${aadharDoc?.identificationNum}`, true);
              setISKYCEntered(true);
              return false;
            }
            setISKYCEntered(false);
          }
          if (disabledApplicantLoanDetailsFlag && (!applicantDetailsReverifyAadhar || (applicantDetailsReverifyAadhar && shouldRender))) {
            setDisabledFields(true);
          }
          setLoanStatus(false);
          if(enabledReKycForDocumentVerification || applicantDetailsReverifyAadhar){
            setHideVendorName(false);
            if (blured === "aadhar") {
              if (aadharIntegrationName === aadharVendor?.authBridgeDigiLocker || aadharIntegrationName === aadharVendor?.ongridDigiLocker || aadharIntegrationName === aadharVendor?.smcAuthBridgeDigiLocker || aadharIntegrationName === aadharVendor?.smcEKYC) {
                  handleAadharCaptureData();
                } else if (aadharIntegrationName ===  ocrVendor) {
                  setShowAadharCaptureModal(true);
                } else if (aadharIntegrationName === aadharVendor?.surePass) {
                  handleAadharCaptureData();
                }
              setLoanStatus(false);
            }
          }else{
            setHideVendorName(true);
              if((blured === "" || blured === undefined) && enableNegativeProfileCheck){
          const apiReponse = await checkNegativeProfileApi(apiHandler,
            endpoint,
            authToken,
            setCallInProgress,
            toastUpdate,
            res?.data?.[0]?.adharNumber,
            res?.data?.[0]?.panNumber,)
             if (apiReponse?.[0]?.risk) {
              setNegativePresent(apiReponse?.[0]?.risk)
              proceedApplication();
            }
          }
          }
        }
      }
    } else {
      setHideVendorName(false);
      if (blured === "aadhar") {
        if (aadharIntegrationName === aadharVendor?.authBridgeDigiLocker || aadharIntegrationName === aadharVendor?.ongridDigiLocker || aadharIntegrationName === aadharVendor?.smcAuthBridgeDigiLocker || aadharIntegrationName === aadharVendor?.smcEKYC) {
            handleAadharCaptureData();
          } else if (aadharIntegrationName === aadharVendor?.authBridgeOCR ||aadharIntegrationName === aadharVendor?.smcAuthBridgeOCR) {
            setShowAadharCaptureModal(true);
          } else if (aadharIntegrationName === aadharVendor?.surePass) {
            handleAadharCaptureData();
          }
        setLoanStatus(false);
      }
      if (blured === "aadharBlur") {
        setDocumentNumber("");
      }
      if (blured === "PAN") {
        setLoanStatus(false);
        verifyPAN();
      }
      setLoanStatus(false);
    }
  };

  const verifyAadharOtp = async (code) =>{
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.AADHAR_DETAILS,
      method: "POST",
      authToken: authToken,
      data:{
        transactionId: tsTransID,
        otp:code,
        vendor:aadharIntegrationName,
        }
    });
    setCallInProgress(false);
      setShowModal(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
      } else {
        setAadharOtpModal(false);
        const aadharDetailsNumber = aadharNumber ?? documentNumber;
        const aadharTransaction = {
          transactionId: tsTransID,
          loanApplicationId,
          loanApplicationNumber,
          aadharNumber: aadharDetailsNumber,
          aadharTransaction,
        }
        setApplicantDetailAgainstId(true);
        updateRecords(aadharTransaction, res?.data, aadharVendor?.surePass)
      }
  }
  const sendEMailOtp = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.APPLICANT_EMAIL_OTP,
      method: "POST",
      authToken: authToken,
      data: {
        type: "EMAIL",
        source: email?.toLowerCase(),
        messageType: 0,
        otp: "null",
      },
    });
    setCallInProgress(false);
    setId(res?.data?.id);
    if (res?.data?.id) {
      setShowModal(true);
    }
  };
  const verifyOtp = async (otp) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.APPLICANT_EMAIL_VERIFY + id + "/" + otp,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    setShowModal(false);
    if (res?.data?.error_code) {
      setEmailValidationAttempted({ error: true });
      setEmailVerify("error");
      setEmailState(true);
      // setEmail('');
      toastUpdate("Error", res?.data?.user_description, true);
      setTimeout(() => {
        setShowModal(true);
        setModalReOpen(true);
      }, 3000);
    } else {
      setModalReOpen(false);
      setEmailVerify("success");
      setEmailState(false);
      setEmailValidationAttempted({ success: true });
      toastUpdate("Success", "Email verified successfully", true);
    }
  };
  const aadharCardValidate = (aadhar) => {
    var adharcardTwelveDigit = /^\d{12}$/;

    if (aadhar !== "" && typeof aadhar !== "undefined") {
      if (aadhar?.match(adharcardTwelveDigit)) {
        setDocumentNumberState(false);
        if (panAmountValidate(checkActualLoanAmountPerYear, actualLoanAmount,  PANCRITERIA, iflActualLoanAmount, YEARLYPANCRITERIA) && !firstTab) {
          if (
            panApplicantNumber !== "" &&
            typeof panApplicantNumber !== "undefined" &&
            panApplicantName !== "" &&
            typeof panApplicantName !== "undefined" &&
            panVerified === true
          ) {
            setPanApplicantNumberState(false);
            return true;
          } else {
            setPanApplicantNumberState(true);
            return false;
          }
        } else {
          return true;
        }
      } else {
        setDocumentNumberState(true);
        toastUpdate("Error", "Enter valid Aadhar Number", true);
        return false;
      }
    }
  };
  useEffect(() => {
    const minimumDateOfBirth = setyear(maxAgeForDateOfBirth);
    const dob = new Date(dateOfBirth);
    if (dob < minimumDateOfBirth) {
        toastUpdate("Information",`Date of birth can not be less than ${maxAgeForDateOfBirth} years`,true)
    }
  }, [dateOfBirth]);
  const minimumDate = setyear(maxAgeForDateOfBirth);
  const maxDate = setyear(minAgeForDateOfBirth);
  const dob = new Date(dateOfBirth);
  const isAgeValid =
      dob >= minimumDate &&
      dob <= maxDate;
  const isValidated = () => {
    if(aadharIntegrationVerified && documentName === documentNamesList?.aadhaar && aadharIntegrationName !== aadharVendor?.manual){
    toastUpdate("Error","Please do aadhar verification first",true);
    return;
    }
   if((documentName === documentNamesList?.passport || documentName === documentNamesList?.drivingLicense) && (documentExpiry === "" || typeof documentExpiry === "undefined" || documentExpiry === null)){
      setDocumentExpiryState(true);
    } else {
      setDocumentExpiryState(false);
    }
    if(showPreFixName && ((prefixName === "Mr" && gender === "Female") || ((prefixName === "Mrs" || prefixName === "Miss") && gender === "Male"))){
      setPreFixNameState(true);
    } else {
      setPreFixNameState(false);
    }
    if (panApplicantNumber?.length > 0 && panApplicantNumber?.length < 10) {
      setPanApplicantNumberState(true);
      return false;
    } else {
      setPanApplicantNumberState(false);
    }
     setDocumentNameState(documentName === "" || typeof documentName === "undefined");
     setDocumentNumberState(documentNumber === "" || typeof documentNumber === "undefined");
    setAadharApplicantNameState(aadharApplicantName?.trim() === "" ||typeof aadharApplicantName === "undefined");
    setAadharFatherNameState(aadharFatherName?.trim() === "" || typeof aadharFatherName === "undefined");
    setDateOfBirthState(dob < minimumDate);
    setDateOfBirthState( dateOfBirth === "" || typeof dateOfBirth === "undefined" ||  parseDate(dateOfBirth) === "NaN-NaN-NaN" );
    setHouseNumberState( houseNumber === "" || typeof houseNumber === "undefined");
    setStreetState(street === "" || typeof street === "undefined");
    setLocalityState(locality === "" || typeof locality === "undefined");
    setPostOfficeState(postOffice === "" || typeof postOffice === "undefined");
    setVillageTownCityState( villageTownCity === "" || typeof villageTownCity === "undefined");
    setStateNameState(stateName === "" || typeof stateName === "undefined");
    setDistrictState(district === "" || typeof district === "undefined");
    setMotherNameErrorState(motherName?.trim() === "" || typeof motherName === "undefined");
    setMemberCountError(memberCount === "" || typeof memberCount === "undefined");
    setSpouseNameState(maritalStatus === "Married" && (spouseName === "" || typeof spouseName === "undefined"));
    setmaritalStatusState( maritalStatus === "" || typeof maritalStatus === "undefined");
    setPincodeState(pincode === "" || typeof pincode === "undefined" || !isValidPincode(pincode));
    setMobileNumberState(mobileNumber && mobileNumber.length !== 10);
    setAnnualIncomeState(annualIncome === "" || typeof annualIncome === "undefined" || Number(annualIncome) < Number(annualIncomeAmount) );
    setEmailState(emailVerify === "error");
    sameAddress ? setHouseNumberState(houseNumber === "" || typeof houseNumber === "undefined" || houseNumber === null)
      : setHouseCorrNumberState(coresHouseNumber === "" || typeof coresHouseNumber === "undefined" || coresHouseNumber === null);
    sameAddress? setStreetState(street === "" || typeof street === "undefined" || street === null)
      : setStreetCorrState(coresStreet === "" || typeof coresStreet === "undefined" || coresStreet === null);
    sameAddress ? setLocalityState(locality === "" || typeof locality === "undefined" || locality === null)
      : setLocalityCorrState(coresLocality === "" || typeof coresLocality === "undefined" || coresLocality === null);
    sameAddress ? setPostOfficeState(postOffice === "" || typeof postOffice === "undefined" || postOffice === null)
      : setPostOfficeCorrState( coresPostOffice === "" || typeof coresPostOffice === "undefined" || coresPostOffice === null);
    sameAddress ? setVillageTownCityState(villageTownCity === "" || typeof villageTownCity === "undefined" || villageTownCity === null)
      : setVillageTownCityCorrState(coresVillage === "" || typeof coresVillage === "undefined" || coresVillage === null);
    sameAddress? setStateNameState(stateName === "" || typeof stateName === "undefined" || stateName === null)
      : setStateNameCorrState(coresState === "" || typeof coresState === "undefined" || coresState === null);
    sameAddress ? setDistrictState(district === "" || typeof district === "undefined" || district === null)
      : setDistrictCorrState( coresDistrict === "" || typeof coresDistrict === "undefined" || coresDistrict === null);
    sameAddress? setPincodeState(pincode === "" || typeof pincode === "undefined"  || pincode === null || !isValidPincode(pincode))
      : setPincodeCorrState(coresPinCode === "" || typeof coresPinCode === "undefined" || coresPinCode === null || !isValidPincode(coresPinCode));
    if (digilance && (digilanceState === "" || typeof digilanceState === "undefined" || digilanceState === null)) {
      setDueDigilance(true);
      return false;
    } else {
      setDueDigilance(false);
    }
    if (
      panApplicantNumber &&
      (panApplicantName?.trim().length === 0 ||
        typeof panApplicantName === "undefined" ||
        panApplicantName === null)
    ) {
      toastUpdate("Error", "Please Verify Pan", true);
      return false;
    }

    console.log(isAgeValid,"dahkfkdhg")
    if (
      (isAadharAvailable
        ? aadharNumber &&
        aadharNumber !== "" &&
        isAgeValid
        : documentName &&
          documentName !== "" &&
          documentNumber &&
          documentNumber !== "") &&
      dateOfBirth &&
      dateOfBirth !== "" &&
      parseDate(dateOfBirth) !== 'NaN-NaN-NaN' &&
      aadharFatherName &&
      aadharFatherName?.trim() !== "" &&
      aadharApplicantName &&
      aadharApplicantName?.trim() !== "" &&
      houseNumber &&
      houseNumber !== "" &&
      street &&
      street !== "" &&
      locality &&
      locality !== "" &&
      postOffice &&
      postOffice !== "" &&
      villageTownCity &&
      villageTownCity !== "" &&
      district &&
      district !== "" &&
      pincode &&
      isValidPincode(pincode) &&
      stateName &&
      stateName !== "" &&
      motherName &&
      motherName?.trim() !== "" &&
      memberCount &&
      isValidValue(memberCount) &&
      enabledCreditAssessmentOnLoanDetails ||
      (enableFamilyDetailsTab && enableCreditAssesmentOnBtCases
        ? true
        : annualIncome &&
          isValidValue(annualIncome) &&
          Number(annualIncome) >= Number(annualIncomeAmount)) &&
      maritalStatus &&
      isValidValue(maritalStatus) &&
      ((documentName === documentNamesList?.passport || documentName === documentNamesList?.drivingLicense) && documentExpiry !== "" || (documentName !== documentNamesList?.passport && documentName !== documentNamesList?.drivingLicense)) &&
      (sameAddress
        ? houseNumber &&
          houseNumber !== "" &&
          pincode &&
          isValidPincode(pincode) &&
          stateName &&
          stateName !== "" &&
          street &&
          street !== "" &&
          locality &&
          locality !== "" &&
          villageTownCity &&
          villageTownCity !== "" &&
          district &&
          district !== "" &&
          postOffice &&
          postOffice !== "" &&
          ((mobileNumber && mobileNumber.length === 10) || !mobileNumber)
        : coresHouseNumber &&
          coresHouseNumber !== "" &&
          coresStreet &&
          coresStreet !== "" &&
          coresDistrict &&
          coresDistrict !== "" &&
          coresVillage &&
          coresVillage !== "" &&
          coresLocality &&
          coresLocality !== "" &&
          coresPostOffice &&
          coresPostOffice !== "" &&
          coresPinCode &&
          isValidPincode(coresPinCode) &&
          coresState &&
          coresState !== "" &&
          houseNumber &&
          houseNumber !== "" &&
          pincode &&
          isValidPincode(pincode) &&
          street &&
          street !== "" &&
          locality &&
          locality !== "" &&
          villageTownCity &&
          villageTownCity !== "" &&
          district &&
          district !== "" &&
          postOffice &&
          postOffice !== "" &&
          stateName &&
          stateName !== ""
         ) &&
         (!showPreFixName ||
          (showPreFixName &&
            ((prefixName === "Mr" && gender !== "Female") ||
              ((prefixName === "Mrs" || prefixName === "Miss") && gender !== "Male")))
        ) && ((mobileNumber && mobileNumber.length === 10) || !mobileNumber) 
    ) {
      if (documentName === documentNamesList?.aadhaar) {
        return aadharCardValidate(documentNumber);
      } else if(!firstTab) {
        if (panAmountValidate(checkActualLoanAmountPerYear, actualLoanAmount,  PANCRITERIA, iflActualLoanAmount, YEARLYPANCRITERIA) ) {
          if (
            panApplicantNumber !== "" &&
            typeof panApplicantNumber !== "undefined" &&
            panApplicantName !== "" &&
            typeof panApplicantName !== "undefined" &&
            panVerified === true
          ) {
            setPanApplicantNumberState(false);
            return true;
          } else {
            setPanApplicantNumberState(true);
            return false;
          }
        }else{
        return true;
        }
      }else{
        return true
      }
    } else {
      return false;
    }
  };
  const gstStateName = stateList?.filter((item) => item?.code === gst);
  const handlecreateapplicantSubmit = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (isValidated()) {
      clearSessionStorage();
      toastUpdate("", "", false);
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.ADMIN_APPLICANT_CREATE,
        method: "POST",
        authToken: authToken,
        data: {
          loanApplicationId: loanApplicationId,
          email: email && email !== "" ? email?.toLowerCase() : "",
          panNumber: panApplicantNumber && panApplicantNumber !== "" ? panApplicantNumber : null,
          nameOnPanCard:
            panApplicantName && panApplicantName !== "" ? panApplicantName : null,
          adhaarNumber:
            aadharNumber && aadharNumber !== "" ? aadharNumber : null,
          nameOnAdhaar:
            aadharApplicantName && aadharApplicantName !== ""
              ? aadharApplicantName
              : panApplicantName,
          dob: parseDate(dateOfBirth),
          fatherName:
            aadharFatherName && aadharFatherName !== ""
              ? aadharFatherName
              : null,
          dueDiligence: digilanceState,
          addresses: [
            {
              addressType: "PERMANENT_ADDRESS",
              houseNumber:
                houseNumber && houseNumber !== "" ? houseNumber : null,
              street: street && street !== "" ? street : null,
              locality: locality && locality !== "" ? locality : null,
              postOffice: postOffice && postOffice !== "" ? postOffice : null,
              villageTownCity:
                villageTownCity && villageTownCity !== ""
                  ? villageTownCity
                  : null,
              state: stateName && stateName !== "" ? stateName : null,
              district: district && district !== "" ? district : null,
              pincode: pincode && pincode !== "" ? pincode : null,
            },
            {
              addressType: "RESIDENTIAL_ADDRESS",
              houseNumber: sameAddress ? houseNumber : coresHouseNumber,
              street: sameAddress ? street : coresStreet,
              locality: sameAddress ? locality : coresLocality,
              postOffice: sameAddress ? postOffice : coresPostOffice,
              villageTownCity: sameAddress ? villageTownCity : coresVillage,
              state: sameAddress ? stateName : coresState,
              district: sameAddress ? district : coresDistrict,
              pincode: sameAddress ? pincode : coresPinCode,
            },
          ],
        documentName:(disbaledAddharFlag && isAadharAvailable) ? null : documentName && documentName !== "" ? documentName : null,
        documentNumber:(disbaledAddharFlag && isAadharAvailable) ? null : documentNumber && documentNumber !== "" ? documentNumber : null,
          alternateMobileNumber:
            mobileNumber && mobileNumber !== "" ? mobileNumber?.trim() : null,
          gender: gender || "Male",
          occupationType: occupationTypes || OccupationList?.[0],
          gstNumber: gstNumber || "",
          gstState: gst || "",
          sameAddress: sameAddress || false,
          adhaarAvailable: applicantDetailsReverifyAadhar && aadharIntegrationName !== "MANUAL" ? true : isAadharAvailable,
          spouseName: maritalStatus === "Single" ? "NA" : spouseName || "NA",
          maritalStatus: maritalStatus || "",
          memberCount: Number(memberCount) || "",
          motherName: motherName || "",
          applicantNamePrefix: prefixName || "Mr",
          documentExpiry: (documentName === documentNamesList?.passport || documentName === documentNamesList?.drivingLicense) ? parseDate(documentExpiry) : '',
          aadhaarVendor: isAadharAvailable ? aadharIntegrationName : '',
          panVerified: panVerified,
          customerRisk:negativePresent || false,
          ...(
            !enableFamilyDetailsTab ||
            subStatus === APPLICATION_SUB_TYPE_PRE_PLEDGE
              ? {
                  purposeOfLoan: enableFamilyDetailsTab
                    ? ""
                    : purposeOfLoan || PurposeOfLoan?.[0],
              
                  applicantAnnualIncome: annualIncome
                      ? annualIncome
                      : "",
                }
              : {}
          ),
          ...(showCustomerType && {customerType:customerType})
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        toastUpdate("Success", "Create Applicant successfully", true);
        setNext();
      }
    } else {
      console.log(isAgeValid,"dahkfkdhg1111")
      if (!isAgeValid) {
   toastUpdate("Information", `Date of birth can not be less than ${minAgeForDateOfBirth} years more than ${maxAgeForDateOfBirth}`, true)
        return true;
      }
         else if (documentName === documentNamesList?.aadhaar) {
        return aadharCardValidate(documentNumber);
      } else {
        toastUpdate("Error", "Please fill all the fields", true);
        return false;
      }
    }
  };
  // cancel button function
  const handlecancelapplicant = () => {
    dispatch(saveAadharDetails(""));
    setBack();
  };
  const handleAadharCaptureData = async (document1, document2) => {
    const formData = new FormData();
    if (document1?.file) {
      formData.append("frontImage", document1.file, document1.name);
    }
    if (document2?.file) {
      formData.append("backImage", document2.file, document2.name);
    }
    formData.append("data", JSON.stringify({
        redirectUrl: window.location.origin + "/aadhar-oauth",
        adhaarNumber: aadharNumber ?? documentNumber,
        vendor: aadharIntegrationName,
        customerName:aadharApplicantName,
        mobileNumber:mobileNum,
        loanApplicationId:loanApplicationId,
      })
    );
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.AADHAR_INIT,
      method: "POST",
      authToken,
      data: formData,
    });
    setCallInProgress(false);
    if (result?.data?.error_code || result?.data?.error) {
      toastUpdate( "Error",result?.data?.user_description || result?.data?.error,true );
      setAadharValidationAttempted({ error: true });
    } else {
        let intervalId;  
      if (customerBasedDigiLocker  && (aadharIntegrationName === aadharVendor?.smcAuthBridgeDigiLocker || aadharIntegrationName === aadharVendor?.smcEKYC)) {
        toastUpdate("Information", "Customer Based Authentication initiated", true);
        const storageKey = "loanApplicationData";
          const existingData = JSON.parse(sessionStorage.getItem(storageKey)) || [];
          const index = existingData.findIndex(
            item => item.loanApplicationId === loanApplicationId
          );
          if (index !== -1) {
            existingData[index].aadhaarNumber = aadharNumber ?? documentNumber;
          } else {
            existingData.push({
              loanApplicationId,
              aadhaarNumber: aadharNumber ?? documentNumber,
              vendorName: aadharIntegrationName,
              timeStamp: new Date().toISOString(),
            });
          }
          sessionStorage.setItem(storageKey, JSON.stringify(existingData));
        setAadhaarPollingLoading(true);
        let retryCount = 0;
        const maxRetry = 6;   
        setAadhaarPollingLoading(true);
        intervalId = setInterval(async () => {
          retryCount++;
          const isLastAttempt = retryCount >= maxRetry;
          let success = false;
            success = await checkAadharDetails(isLastAttempt, false, aadharIntegrationName);
          if (success || isLastAttempt) {
            clearInterval(intervalId);
            setAadhaarPollingLoading(false);
            setLoanStatus(false);
            if (!success && isLastAttempt) {
              toastUpdate("Error", "Aadhaar verification timeout try again", true);
              setLoanStatus(true);
            }
          }
        }, 60000);
      }else if(result?.data?.transactionId && result?.data?.otp){
         setAadharOtpModal(true);
         setTsTransID(result?.data?.transactionId);
         setAadharIntegrationVerified(false);
      }else if (result?.data?.url && result?.data?.transactionId) {
        setAadharIntegrationVerified(false);
        const { transactionId, url } = result.data;
         const numberToSave = aadharNumber ?? documentNumber;
        dispatch(
          saveAadharTransaction({
            transactionId,
            loanApplicationId,
            loanApplicationNumber,
            aadharNumber: numberToSave,
            isAadharAvailable,
            aadharIntegrationName,
          })
        );
        setTsTransID(transactionId);
        if (url?.includes("signup")) {
          setConfirmationModalDigiloker(true);
          setConfirmationModalHeaderDigiloker("Error");
          setConfirmationModalMsgDigiloker(
            "This mobile number is not linked with Aadhaar. Please verify through OCR."
          );
          setDigilokerSignUpUrl(url)
          return;
        }
        if (aadharIntegrationName === aadharVendor?.ongridDigiLocker) {
          const newEntry = {
            loanApplicationId,
            timestamp: Date.now(),
          };
          if (existingIndex !== -1) {
            existingData[existingIndex] = newEntry;
          } else {
            existingData.push(newEntry);
          }
          sessionStorage.setItem(storageKey, JSON.stringify(existingData));
        }
        window.location.href = url;
      } else {
        setAadharIntegrationVerified(false);
        const enteredAadhar = String(documentNumber || aadharNumber)
          .replace(/\D/g, "")
          .slice(-4);
              
        const apiAadhar = String(result?.data?.adhaarNumber || "")
          .replace(/\D/g, "")
          .slice(-4);
        if (apiAadhar.length === 12 && enteredAadhar !== apiAadhar) {
          toastUpdate("Error", "Aadhar number does not match", true);
          setAadharValidationAttempted({ error: true });
          return false;
        }
        if(result?.data?.adhaarNumber === "" || result?.data?.adhaarNumber === null || typeof result?.data?.adhaarNumber === "undefined"){
          toastUpdate("Error", "Aadhar details not found, please try again", true);
          setAadharValidationAttempted({ error: true });
          return false;
        }
        setShowAadharCaptureModal(false);
         if (
          applicantDetailsReverifyAadhar &&
          isKYCReliazed &&
          (
            !result?.data?.name ||
            !result?.data?.dob ||
            !result?.data?.postOffice || 
            !result?.data?.pincode || 
            !result?.data?.district 
          )
        ) {
          setEnabledSendToHOButton(true);
          toastUpdate("Error", "Aadhar is not authenticated successfully please verify with HO",true);
          setISKYCEntered(true);
          setAadharValidationAttempted({ error: true });
        }else{
          setISKYCEntered(false);
          setAadharValidationAttempted({ success: true });
        }
        setDocumentDisable(true);
        const rawDob = result?.data?.dob;
        const parsedDob = parseDob(rawDob);
        const pincodeTrim = result?.data?.pincode?.trim();
        const isPincode = isValidPincode(pincodeTrim);
        const postOffice = result?.data?.postOffice?.trim();
        const isPostOffice = isValidateOnlyAlphabets(postOffice, enabledAddressDetailsValidate);
        const villageTownCity = result?.data?.villageTownCity?.trim();
        const isVillageTownCity = isValidateOnlyAlphabets(villageTownCity, enabledAddressDetailsValidate);
        const district = result?.data?.district?.trim();
        const isDistrict = isValidateOnlyAlphabets(district, enabledAddressDetailsValidate);
        setAddressDetailsAvailable((prev) => ({
          ...prev,
        
          ...(result?.data?.fatherName?.trim() && {
            fatherNameState: true,
          }),
        
          ...(result?.data?.houseNumber?.trim() && {
            houseState: true,
          }),
        
          ...(result?.data?.street?.trim() && {
            streetState: true,
          }),
        
          ...(result?.data?.locality?.trim() && {
            localityState: true,
          }),
        
          ...(postOffice && {
            postOfficeState: isPostOffice,
          }),
        
          ...(villageTownCity && {
            villageState: isVillageTownCity,
          }),
        
          ...(result?.data?.state?.trim() && {
            state: true,
          }),
        
          ...(district && {
            districtState: isDistrict,
          }),
        
          ...(pincodeTrim && {
            pincodeState: isPincode,
          }),
          
          ...(result?.data?.gender?.trim() && {
            genderState: true,
          }),
          
          ...(parsedDob && {
            dob: true,
          }),
        }));
          
        if (result?.data?.adhaarNumber) {
          if(result?.data?.adhaarNumber.length === 12 && aadharIntegrationName !== aadharVendor?.smcAuthBridgeOCR){
            setAadharNumber(result?.data?.adhaarNumber?.replace(/\s+/g, '')?.slice(0, 12))
          }else{
            setAadharNumber(documentNumber || aadharNumber)
          }
          setAadharNumberState(false);
        }
        if (isDistrict) {
          setDistrict(textFormat(result?.data?.district));
          setDistrictState(false);
        }
        if (result?.data?.dob) {
          if (parsedDob) {
            setDateOfBirth(parsedDob);
            setDateOfBirthState(false);
          }
        }
        if (result?.data?.fatherName) {
          setAadharFatherName(textFormat(result?.data?.fatherName));
          setAadharFatherNameState(false);
        }
        setAadharIntegrationName(ocrVendor);
        if (result?.data?.houseNumber) {
          setHouseNumber(result?.data?.houseNumber);
          setHouseNumberState(false);
        }
        if (result?.data?.locality) {
          setLocality(result?.data?.locality);
          setLocalityState(false);
        }
        if (result?.data?.name) {
          setAadharApplicantName(textFormat(result?.data?.name));
          setAadharApplicantNameState(false);
        }
        if (isPostOffice) {
          setPostOffice(result?.data?.postOffice);
          setPostOfficeState(false);
        }
        if (result?.data?.street) {
          setStreet(result?.data?.street);
          setStreetState(false);
        }
        if (isVillageTownCity) {
          setVillageTownCity(textFormat(result?.data?.villageTownCity));
          setVillageTownCityState(false);
        }
        if (result?.data?.state) {
          setStateName(result?.data?.state);
          // setStateNameState(false);
        }
        if (isPincode) {
          setPincode(result?.data?.pincode);
          setPincodeState(false);
        }
        if (result?.data?.gender) {
          setGenderDetails(capitalizeFirstLetter(result?.data?.gender));
        }
        if (result?.data?.name && result?.data?.name !== "") {
          setIsAadharAvailable(true);
          setAadharVerified(true);
        } else {
          setIsAadharAvailable(false);
          setAadharVerified(false);
        }
      }
    }
  };
  const handleSwitchChange = async () => {
    dispatch(saveAadharDetails(""));
    dispatch(saveLoanApplicantDetails(""));
    setAadharApplicantName("");
    setDateOfBirth("");
    setAadharFatherName("");
    setHouseNumber("");
    setStreet("");
    setLocality("");
    setPostOffice("");
    setVillageTownCity("");
    setStateName("");
    setDistrict("");
    setPincode("");
    setEmail("");
    setDocumentDisable(false);
    setMotherName("");
    setMateritalStatus("");
    setAnnualIncome("0");
    setMemberCount("");
    setSpouseName("");
    await setDocumentName("");
    await setDocumentNumber("");
    await setAadharNumber("");
    await setAadharVerified(false);
    await setIsAadharAvailable(!isAadharAvailable);
  };
  const handlenext = () => {
    setNext();
  };
  const back = () => {
    setBack();
  };

  const emaildataVerify = (e) => {
    setEmail(e);
    if (e !== "") {
      setEmailVerify("error");
    } else {
      setEmailVerify("success");
    }
  };
  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setMobileNumber(e);
    }
  };
const handleChange1 = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setPincode(e);
    }
  };
 const setAnnualIcomeBlur = (e)=>{
    if(Number(e) < Number(annualIncomeAmount))
 toastUpdate("Error", `Annual Income should be equal or more than ${annualIncomeAmount}`, true)
  }

  const handleChange3 = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setMemberCount(e);
    }
  };
  const handleChange4 = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setAnnualIncome(e);
    }
  };
  const handleCorspinCode = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setCoresPinCode(e);
    }
  };
  const updateApplicantName = (e)=>{
      setAadharApplicantName(e)
    }
    const checkedDueDigilance =(e)=>{
      setDigilance(e.target.checked)
      if(e.target.checked === false){
        setDigilanceState("")
      }
    }
 const handlePreFixName = (e) => {
      setPreFixName(e);
      const gender = prefixToGenderMap[e] || "Other";
      setGender(gender);
    };

    const handleGenderChange = (e) => {
      setGender(e);
      const prefix = genderToPrefixMap[e] || "";
      setPreFixName(prefix);
    };
    const closeAadharCaptureModal = () => {
      setShowAadharCaptureModal(false);
    };
    const handleAadharInegration = async (e) => {
      setAadharIntegrationName(e);
      dispatch(saveAadharDetails(""));
      dispatch(saveLoanApplicantDetails(''))
      setAadharApplicantName("");
      setDateOfBirth("");
      setAadharFatherName("");
      setHouseNumber("");
      setStreet("");
      setLocality("");
      setPostOffice("");
      setVillageTownCity("");
      setStateName("");
      setDistrict("");
      setPincode("");
      setDocumentDisable(false)
      setMotherName("");
      setMateritalStatus("");
      setAnnualIncome("0");
      setMemberCount("");
      setSpouseName("");
      if(e === 'MANUAL'){
        setIsAadharAvailable(false);
      }else{
        setIsAadharAvailable(true);
      }
    }
    const handleDocumentName = async (e) => {
      setDocumentName(e);
      setIsAadharAvailable(false);
    }
    const getAddressDisabled = (fieldState) => {
      return (
        !editable ||
        !(
          enabledApplicantFieldsForRootHierarcy &&
          userDetails?.rootHierarchy
        ) &&
        !enabledReKycForDocumentVerification &&
        (
          (isAadharAvailable && fieldState) ||
          disabledFields ||
          loanStatus
        )
      );
    };
     const closeConfirmationModal = () => {
       setConfirmationModal(false);
       setConfirmationModalHeader("");
       setConfirmationModalMsg("");
     };
     
     const handleNegativeResponse = () => {
       closeConfirmationModal();
       setRiskPresent(true);
     };
     
     const handlePositiveResponse = () => {
       closeConfirmationModal();
       setRiskPresent(false);
     };
    const proceedApplication = () => {
      setConfirmationModalHeader("Risk Warning");
      setConfirmationModalMsg(
        "Customer is in negative list, Do you want to proceed"
      );
      setConfirmationModal(true);
    };
    const checkAadharDetails = async (showError = false , storage = false, integrationName = '') => {
      const storedData =
        JSON?.parse(sessionStorage?.getItem("loanApplicationData")) || [];
      const matchedLoan = storedData?.find(
        item => item?.loanApplicationId === loanApplicationId
      );
      const is15MinutesDone = matchedLoan?.timeStamp
      ? Date.now() - new Date(matchedLoan.timeStamp).getTime() >= 15 * 60 * 1000
      : true;
      const result = await apiHandler({
        url: endpoint.GET_AADHAR_DETAILS + loanApplicationId,
        method: "GET",
        authToken: authToken,
      });
      const status = result?.data?.status?.trim()?.toUpperCase();
      if(result?.data?.error_code){
        if (showError) {
          toastUpdate("Error", result?.data?.user_description, true);
          if(!is15MinutesDone){
            setIsCustomerInit(true);
          }else{
            setIsCustomerInit(false);
          }
        }
        return false;
      }else if (status === statusList.initiated) {
        setAadharNumber(matchedLoan?.aadhaarNumber);
        setAadharIntegrationName(integrationName);
        setIsAadharAvailable(true);
        toastUpdate("Information", "eKYC is in the initiated stage. Please wait for it to complete.", true);
        if(!is15MinutesDone){
          setIsCustomerInit(true);
        }else{
          setIsCustomerInit(false);
        }
        return false;
      }else if (status?.toUpperCase() === statusList.failure || status?.toUpperCase() === statusList.failed)  {
        toastUpdate("Error", "eKYC failed. Please try again.", true);
        setIsCustomerInit(false);
        return false;
      }else{
        setIsCustomerInit(false);
        let aadhaarToCompare = aadharNumber;
        if (storage) {
          aadhaarToCompare = matchedLoan?.aadhaarNumber || "";
          setAadharNumber(matchedLoan?.aadhaarNumber?.replace(/\s+/g, '')?.slice(0, 12))
        }
        const isMatched =
          result?.data?.adhaarNumber?.slice(-4) || result?.data?.maskedAdhaarNumber?.slice(-4) === aadhaarToCompare?.slice(-4);
        if (!isMatched) {
          toastUpdate("Error", "Aadhar Number is not matched", true);
          return true;
        }
        setShowAadharCaptureModal(false);
        setAadharValidationAttempted({ success: true });
        setDocumentDisable(true);
        const rawDob = result?.data?.dob;
        const parsedDob = parseDob(rawDob);
        const documentLinks =
          integrationName === aadharVendor?.smcEKYC
            ? [result?.data?.photoContent?.trim()].filter(Boolean)
            : [
                result?.data?.adhaarDocumentLink?.trim(),
                result?.data?.panDocumentLink?.trim(),
              ].filter(Boolean);
          setCallInProgress(true);
          const res = await apiHandler({
            url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
            method: "POST",
            authToken: authToken,
            data: {
              loanApplicationId: loanApplicationId,
            
              ...(integrationName === aadharVendor?.smcEKYC
                ? {
                    kycDocumentLink: result?.data?.photoContent?.trim(),
                  }
                : {
                    documentPhotoLinks: documentLinks,
                  }),
            },
          });
          setCallInProgress(false);
          const postOffice = result?.data?.postOffice?.trim();
          const isPostOffice = isValidateOnlyAlphabets(postOffice, enabledAddressDetailsValidate);
          const villageTownCity = result?.data?.villageTownCity?.trim();
          const isVillageTownCity = isValidateOnlyAlphabets(villageTownCity, enabledAddressDetailsValidate);
          const district = result?.data?.district?.trim();
          const isDistrict = isValidateOnlyAlphabets(district, enabledAddressDetailsValidate);
            setAddressDetailsAvailable((prev) => ({
            ...prev,
          
            ...(result?.data?.fatherName?.trim() && {
              fatherNameState: true,
            }),
          
            ...(result?.data?.houseNumber?.trim() && {
              houseState: true,
            }),
          
            ...(result?.data?.street?.trim() && {
              streetState: true,
            }),
          
            ...(result?.data?.locality?.trim() && {
              localityState: true,
            }),
          
            ...(postOffice && {
              postOfficeState: isPostOffice,
            }),
          
            ...(villageTownCity && {
              villageState: isVillageTownCity,
            }),
          
            ...(result?.data?.state?.trim() && {
              state: true,
            }),
          
            ...(district && {
              districtState: isDistrict,
            }),
          
            ...(result?.data?.pincode?.trim() && {
              pincodeState: true,
            }),

            ...(result?.data?.gender?.trim() && {
              genderState: true,
            }),
          
            ...(parsedDob && {
              dob: true,
            }),
          }));
            if (result?.data?.adhaarNumber) {
              // setAadharNumber(result?.data?.adhaarNumber?.replace(/\s+/g, '')?.slice(0, 12))
              setAadharNumberState(false);
            }
            if (isDistrict) {
              setDistrict(textFormat(result?.data?.district));
              setDistrictState(false);
            }
            if (result?.data?.dob) {
              if (parsedDob) {
                setDateOfBirth(parsedDob);
                setDateOfBirthState(false);
              }
            }
            if(result?.data?.panNumber){
              setPanApplicantNumber(result?.data?.panNumber);
              setPanApplicantNumberState(false);
            }
            if (result?.data?.fatherName) {
              setAadharFatherName(textFormat(result?.data?.fatherName));
              setAadharFatherNameState(false);
            }
            setAadharIntegrationName(integrationName);
            if (result?.data?.houseNumber) {
              setHouseNumber(result?.data?.houseNumber);
              setHouseNumberState(false);
            }
            if (result?.data?.locality) {
              setLocality(result?.data?.locality);
              setLocalityState(false);
            }
            if (result?.data?.name) {
              setAadharApplicantName(textFormat(result?.data?.name));
              setAadharApplicantNameState(false);
            }
            if (isPostOffice) {
              setPostOffice(result?.data?.postOffice);
              setPostOfficeState(false);
            }
            if (result?.data?.street) {
              setStreet(result?.data?.street);
              setStreetState(false);
            }
            if (isVillageTownCity) {
              setVillageTownCity(textFormat(result?.data?.villageTownCity));
              setVillageTownCityState(false);
            }
            if (result?.data?.state) {
              setStateName(result?.data?.state);
              // setStateNameState(false);
            }
            if (isValidPincode(result?.data?.pincode)) {
              setPincode(result?.data?.pincode);
              setPincodeState(false);
            }
            if (result?.data?.gender) {
              setGenderDetails(capitalizeFirstLetter(result?.data?.gender));
            }
            if (result?.data?.name && result?.data?.name !== "") {
              setIsAadharAvailable(true);
              setAadharVerified(true);
              return true;
            } else {
              setIsAadharAvailable(false);
              setAadharVerified(false);
              return false;
            }
          }
        }
    const searchAadharDetails = async () => {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.KYC_APPROVAL_API_STATUS + loanApplicationId,
        method: "GET",
        authToken,
      });
      setCallInProgress(false);
      if(result?.data?.error_code){
        toastUpdate("Error",result?.data?.user_description,true);
        return;
      }
      const leadEnteredData = result?.data?.filter((item) => item?.status === "ENTERED")
      const leadRejectedData = result?.data?.filter((item) => item?.status === "REJECTED")
      const leadApprovalData = result?.data?.filter((item) => item?.status === "REALIZED")
      if(leadEnteredData?.length > 0){
        toastUpdate("Information","This application is send for HO verification",true);
        setISKYCEntered(true);
        return;
      }
      if(leadApprovalData?.length > 0){
        toastUpdate("Success","KYC data approved",true);
        setDocumentNumber(leadApprovalData?.[0].kycNumber);
        setDocumentName(documentNamesList?.aadhaar);
        setAadharIntegrationName(ocrVendor);
        setISKYCEntered(false);
        setIsKYCReliazed(false);
        setEnabledKYCFields(false);
        if(existingData[existingIndex] !== -1 &&existingData[existingIndex]){
          setConfirmationModalDigiloker(true);
          setConfirmationModalHeaderDigiloker("Confirmation");
          setConfirmationModalMsgDigiloker(
            "There is no DigiLocker link with this. Please choose an option."
          );
          clearSessionStorage();
        }
        return;
      }
    }
    const aadharDetailsMakerMissingData = async () =>{
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.KYC_APPROVAL_API_CREATE,
        method: "POST",
        authToken,
        data: {
        loanApplicationId: loanApplicationId,
        kycType: "AADHAAR",
        kycNumber: aadharNumber ?? documentNumber,
        remarks: aadharIntegrationName
        },
      });
      setCallInProgress(false);
      if(result?.data?.error_code){
        toastUpdate("Error",result?.data?.user_description,true);
        return;
      }
      toastUpdate("Success","Application send To HO for verification",true);
      setISKYCEntered(true);
    }
    const disableReverifyFields = enabledKYCFields;
    let applicantNameDisabled = true;
    if(!editable){
    	applicantNameDisabled=true
    }else if(enabledFieldsForApplciantPage && editable){
    	applicantNameDisabled = false
    }else if(!disableReverifyFields){
    	applicantNameDisabled=false
    }else if (enabledApplicantFieldsForRootHierarcy && userDetails?.rootHierarchy){
    	applicantNameDisabled=false
    }else{
    	applicantNameDisabled= isAadharAvailable || (disabledFields && panValidate) || (PanNameObj && disabledApplicantLoanDetailsFlag)
    }
    console.log( disableReverifyFields || (((isAadharAvailable || !editable || (disabledFields && panValidate) || loanStatus || (PanNameObj && disabledApplicantLoanDetailsFlag)) && !enabledFieldsForApplciantPage) || (!editable && enabledFieldsForApplciantPage)),"fjkdfbsdkjb")
  return (
    <div>
      <Grid container >
        <Grid item xs={12} sm={12} md={12} className={classes.applicantPageContainer}>
          <SubHeader
            label={headerLabel?.applicant}
            subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
            // onlyLabel
            button1={enabledSendToHOButton ? "Send To HO" : ""}
            button1click={aadharDetailsMakerMissingData}
            />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
         {(showProcessingFeeApplicantFlag && Number(processingFee) >= 0 && subStatus !== "PRE_PLEDGE")  &&  
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Processing Fee(Inclusive of GST)"
              required
              value={Math.round(processingFee).toLocaleString("en-IN") || "0"}
              disabled
              />
          </Grid>}
          {!disbaledAddharFlag && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <FormControlLabel
                control={
                  <Switch
                    checked={isAadharAvailable}
                    onChange={handleSwitchChange}
                    name="checkedB"
                    color="primary"
                    disabled={!editable || documentDisbale || disabledFields}
                  />
                }
                label="Do you have Aadhar No"
              />
          </Grid>}
          {(isAadharAvailable && !disbaledAddharFlag) ? (
            <>
            {aadharIntegrationOptions.length > 1 &&
              <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
                <CustomeSelectNew
                  label="Aadhar Vendor*"
                  id="aadhr_vendor"
                  value={aadharIntegrationName}
                  setState={setAadharIntegrationName}
                  data={aadharIntegrationOptions}
                  type="type"
                  disabled={!editable || documentDisbale}
                />
              </Grid>
            }
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Aadhar No"
              required
              error={aadharNumberState}
              value={aadharNumber || ""}
              setState={setAadharNumber} 
              setError={setAadharNumberState}
              id="aadhar_number"
              visiblityIcon={!editable}
              loanAccountNumber={loanAccountNumber}
              viewType={"Aadhar Card"}
              setBlur={(e)=> SearchProfileData(e, 'aadharBlur')}
              lastFourDigits={Number(aadharNumber) % 10000}
              disabled={!editable || documentDisbale}
              validationState={aadharValidationAttempted}
              validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
              />
          </Grid>
          {(aadharIntegrationName === aadharVendor?.smcAuthBridgeDigiLocker || aadharIntegrationName === aadharVendor?.smcEKYC) &&
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Applicant Name"
             required
             id="Applicant_name"
             error={panApplicantNumber ? nameOnPanCardState:aadharApplicantNameState}
             value={aadharApplicantName || ""}
             setState={updateApplicantName}
             disabled= {disableReverifyFields}
             setError={panApplicantNumber ? setNameOnPanCardState : setAadharApplicantNameState}
             />
         </Grid>
          }
          <>
          {aadharNumber && aadharNumber.length === 12 && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <Button
                size="small"
                className={classes.nextButton1}
                style={{width:'auto',margin:"0px"}}
                onClick={(event) => SearchProfileData(aadharNumber, "aadhar")}
                disabled={applicantDetailAgainstId || isCustomerInit || documentDisbale || (aadharIntegrationName === aadharVendor?.smcAuthBridgeDigiLocker || aadharIntegrationName === aadharVendor?.smcEKYC) && !aadharApplicantName}
              >
                Aadhar Details
              </Button>
            </Grid>
          )}
          {aadharDetails?.adhaarNumber && (
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
              label="Masked Aadhar No"
              required
              value={aadharDetails?.adhaarNumber || ""}
              disabled = {true}
              id="masked_aadhar_card"
              />
            </Grid>
          )}
          </>
          </>
          ):(
            <>
            {!applicantDetailsReverifyAadhar &&
            <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
              <CustomeSelectNew
                label="Document Name*"
                error={documentNameState}
                value={documentName}
                id="document_name"
                setState={handleDocumentName}
                data={documentNameList}
                setError={setDocumentNameState}
                disabled={documentDisbale || !editable  || disabledFields}
                type="displayName"
              />
            </Grid>
          }
          {(disbaledAddharFlag && documentName=== 'AADHAR_CARD' && !hideVendorName) &&
            <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            {(!enabledManualOcrSelect && (aadharIntegrationName === aadharVendor?.authBridgeOCR || aadharIntegrationName === aadharVendor?.authBridgeDigiLocker) && aadharVendorThirdParty !== aadharVendor?.authBridgeDigiLocker) ?
               <CustomeTextField
              label="Aadhar integration"
              required
              value={aadharIntegrationName === aadharVendor?.authBridgeOCR ? "OCR" : "Digilocker"}
              disabled = {true}
              id="aadhar_integration"
              />
            :
            <CustomeSelectNew
              label="Aadhar integration*"
              id="aadhar_integration"
              value={aadharIntegrationName}
              setState={handleAadharInegration}
              data={aadharIntegrationOptions}
              disabled={ !editable || (!enabledReKycForDocumentVerification && (documentDisbale || disabledFields))}
              type="type"
            />
          }
          </Grid>
          }
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Document No"
             required
             id="document_number"
             error={documentNumberState}
             value={documentNumber || ""}
             setState={setDocumentNumber}
             setError={setDocumentNumberState}
             setBlur={(e)=>SearchProfileData(e,'blur')}
             disabled={!editable || documentDisbale || disabledFields}
             visiblityIcon={!editable && documentName === documentNamesList?.aadhaar}
             loanAccountNumber={loanAccountNumber}
             viewType={documentName}
             lastFourDigits={Number(documentNumber) % 10000}
             validationState={aadharValidationAttempted}
             validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
             />
         </Grid>
         {(disbaledAddharFlag && documentNumber?.length === 12 && aadharIntegrationName !== aadharVendor?.manual && documentName=== documentNamesList?.aadhaar  && editable ) &&
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <Button
                size="small"
                className={classes.nextButton1}
                style={{width:'auto',margin:"0px"}}
                onClick={(event) => SearchProfileData(documentNumber, "aadhar")}
                disabled={!enabledReKycForDocumentVerification && (applicantDetailAgainstId || documentDisbale) || isCustomerInit}
              >
                Aadhar Details
              </Button>
            </Grid>
         }
         {(documentName === documentNamesList?.passport || documentName === documentNamesList?.drivingLicense)&& <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <InputLabel
                className={classes.label}
                style={{ textAlign: "left"}}
              >
               Document Expiry*
              </InputLabel>
              <CustomeDateCalender
                error={documentExpiryState}
                handleDateChange={handleDocumentExpiry}
                selectedDate={documentExpiry ? documentExpiry : null}
                id="document_expiry"
                inputProps={{
                  disabled: isAadharAvailable ? true : !editable || documentDisbale ,
                }}
              />
         </Grid>}
         </>
          )}
          {showPreFixName && <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Applicant Pre Name*"
              id="pre_name"
              value={prefixName || PreFixNameList[0]}
              setState={handlePreFixName}
              data={PreFixNameList}
              disabled={!editable}
              setError={setPreFixNameState}
              error={prefixNameState}
            /> 
          </Grid>}
           {(((aadharIntegrationName !== aadharVendor?.smcAuthBridgeDigiLocker && aadharIntegrationName !== aadharVendor?.smcEKYC) && isAadharAvailable) || !isAadharAvailable || disbaledAddharFlag) &&
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Applicant Name"
                required
                id="Applicant_name"
                error={panApplicantNumber ? nameOnPanCardState:aadharApplicantNameState}
                value={aadharApplicantName || ""}
                setState={updateApplicantName}
                disabled= {applicantNameDisabled && aadharIntegrationName !== "MANUAL"}
                setError={panApplicantNumber ? setNameOnPanCardState : setAadharApplicantNameState}
              />
            </Grid>
            }
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Father Name"
             required
             id="father_name"
             error={aadharFatherNameState}
             value={aadharFatherName || ""}
             setState={setAadharFatherName} 
             setError={setAadharFatherNameState}
             disabled= {getAddressDisabled(addressDetailsAvailable?.fatherNameState)}
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Mother Name"
             required
             id="mother_name"
             error={motherNameErrorState}
             value={motherName || ""}
             setState={setMotherName} 
             setError={setMotherNameErrorState}
             disabled= {!editable}
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomDateField
              onChange={handleDateChange}
              value={dateOfBirth ? dateOfBirth : null}
              label="Date Of Birth(DD/MM/YYYY)"
              disabled= {(disableReverifyFields || (!disableReverifyFields && ((((isAadharAvailable ? addressDetailsAvailable?.dob : !editable) || (disabledFields && panValidate) || loanStatus)) && !enabledFieldsForApplciantPage) ||( enabledFieldsForApplciantPage && !editable ))) && aadharIntegrationName !== "MANUAL"}
              minDate={setyear(maxAgeForDateOfBirth)}
              maxDate={setyear(minAgeForDateOfBirth)}
            />
         </Grid>
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Marital Status*"
              error={maritalStatusState}
              value={maritalStatus}
              id="document_name"
              setState={setMateritalStatus}
              data={maritalStatusList}
              setError={setmaritalStatusState}
              disabled= {!editable || loanStatus}
              type="name"
            />
          </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Flat No./House No./Plot No./Building Name"
             required
             error={houseNumberState}
             value={houseNumber || ""}
             id="house_number"
             setState={setHouseNumber} 
             setError={setHouseNumberState}
             disabled={getAddressDisabled(addressDetailsAvailable?.houseState)}
             />
         </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Street"
             required
             id="street"
             error={streetState}
             value={street || ""}
             setState={setStreet} 
             setError={setStreetState}
             disabled={getAddressDisabled(addressDetailsAvailable?.streetState)}
             />
         </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Locality"
             required
             id="locality"
             error={localityState}
             value={locality || ""}
             setState={setLocality} 
             setError={setLocalityState}
             disabled={getAddressDisabled(addressDetailsAvailable?.localityState)}
             />
         </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="PostOffice"
             required
             type="alphabets"
             id="post_office"
             error={postOfficeState}
             value={postOffice || ""}
             setState={setPostOffice}
             setError={setPostOfficeState}
             disabled={getAddressDisabled(addressDetailsAvailable?.postOfficeState)}
             />
         </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Village/Town/City"
             required
             type="alphabets"
             id="village_town"
             error={villageTownCityState}
             value={villageTownCity || ""}
             setState={setVillageTownCity}
             setError={setVillageTownCityState}
             disabled={getAddressDisabled(addressDetailsAvailable?.villageState)}
             />
         </Grid>
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
         {((isAadharAvailable && stateName) || status !== loanStatusNames?.inProcess || disabledFields) && stateName ? (
          <CustomeTextField
          label="State"
          required
          id="state"
          value={stateName ? stateName : ""}
          disabled={getAddressDisabled(addressDetailsAvailable?.state)}
          />
           ):(
            <CustomeSelectNew
            label="State*"
            value={stateName ? stateName : ""}
            setState={setStateName}
            data={stateList}
            type="name"
            id="state"
            disabled={getAddressDisabled(addressDetailsAvailable?.state)}
            />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="District"
             required
             type="alphabets"
             id="district"
             error={districtState}
             value={district || ""}
             setState={setDistrict}
             setError={setDistrictState}
             disabled={getAddressDisabled(addressDetailsAvailable?.districtState)}
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Pincode"
             required
             type="digits"
             id="pincode"
             error={pincodeState}
             value={pincode || ""}
             setState={handleChange1}
             maxLength="6"
             disabled={getAddressDisabled(addressDetailsAvailable?.pincodeState)}
             setError={setPincodeState}
             />
         </Grid>
         {showEmailOnApplicantFlag &&
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}  style={{ position: "relative" }}>
           <CustomeTextField
             label="Email"
            //  required
            id="email"
             error={emailState}
             value={email?.toLowerCase() || ""}
             setState={emaildataVerify} 
             disabled={(isAadharAvailable ? true : !editable) || disabledFields || loanStatus || emailVerify === "success"}
             type='notCapital'
             setError={setEmailState}
             validationState={emailValidationAttempted}
             validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
             />
             {emailVerify !== "success" &&
              <Button
                disabled={!email || (isAadharAvailable ? true : !editable) || disabledFields || loanStatus}
                size="small"
                style={{
                  height: "40px",
                  width: "75px",
                  position: "absolute",
                  right: 0,
                  top: 0,
                  margin:0,
                  backgroundColor:brandTheme.button2Color,
                  color:brandTheme.white
                }}
               onClick={() => sendEMailOtp()}  
              >
                Verify
              </Button>
            }
         </Grid>
          }
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Alternate Mobile Number"
            //  required
            id="alternate_mobile_number"
             error={mobileNumberState}
             value={mobileNumber || ""}
             setState={handleChange} 
             maxLength="10"
             setError={setMobileNumberState}
             disabled={!editable}
             />
         </Grid>
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Gender*"
              id="gender"
              value={gender || GenderList[0]}
              setState={handleGenderChange}
              // type="list"
              data={GenderList}
              disabled={getAddressDisabled(addressDetailsAvailable?.genderState)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Name of Spouse"
             required
             id="spouse_name"
             error={spouseNameState}
             value={maritalStatus === "Single" ? "" : spouseName}
             setState={setSpouseName} 
             setError={setSpouseNameState}
             disabled= {maritalStatus === "Single"||!editable}
             />
         </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Number of Member"
             required
             id="number_member"
             error={memeberCountError}
             value={memberCount}
             setState={handleChange3} 
             setError={setMemberCountError}
             maxLength="3"
             disabled= {!editable}
             />
         </Grid>
         {(!enableFamilyDetailsTab || !enableCreditAssesmentOnBtCases ) && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
           <CustomeTextField
             label="Monthly Income"
             required
             id="annual_income"
             error={annualIncomeState}
             value={annualIncome || ""}
             setState={handleChange4} 
             setError={setAnnualIncomeState}
             disabled= {!editable}
             setBlur={setAnnualIcomeBlur}
             />
         </Grid>}
         <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Occupation Type*"
              id="occupation_type"
              value={occupationTypes || OccupationList?.[0]}
              setState={setoccupationTypes}
              // type="list"
              data={OccupationList}
              disabled={!editable || loanStatus}
            />
          </Grid>
         {(!enableFamilyDetailsTab || !enableCreditAssesmentOnBtCases )&& <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Purpose Of Loan*"
              id="purpose_of_loan"
              value={purposeOfLoan || PurposeOfLoan[0]}
              // type="list"
              setState={setPurposeOfLoan}
              data={PurposeOfLoan}
              disabled={!editable || loanStatus}
            />
          </Grid>}
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Customer Type*"
              id="customer_type"
              value={customerType || customerTypeData[0]?.code}
              type="name"
              setState={setCustomerType}
              data={customerTypeData}
              disabled={!editable || loanStatus}
            />
          </Grid>
          
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          <CustomeTextField
             label="GST Number"
             id="gst_number"
            //  error={mobileNumberState}
             value={gstNumber  || ""}
             setState={setGstNumber} 
            //  setError={setMobileNumberState}
             disabled={!editable || loanStatus}
             type="gst"
             />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          {!editable  ? (
          <CustomeTextField
          label={gstNumber ? "GST State*" : "GST State"}
          required={!!gstNumber}
          id="gst_state"
          value={gstStateName?.length > 0 ? gstStateName?.[0]?.name : ""}
          disabled={!editable}
          />
           ):(
            <CustomeSelectNew
            label={gstNumber ? "GST State*" : "GST State"}
            value={gst ? gst : ""}
            setState={setGst}
            data={stateList}
            type="type"
            id="gst_state"
            disabled={!editable}
            />
            )}
          </Grid>
          <Grid
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
            style={{ position: "relative" }}
          >
            <CustomeTextField
              label="PAN No."
              required={panAmountValidate()}
              error={panApplicantNumberState}
              id="pan_number"
              value={panApplicantNumber?.toUpperCase()}
              setState={setPanApplicantNumber}
              setError={setPanApplicantNumberState}
              type="notCapital"
              maxLength="10"
              disabled={panNumberDisabled}
              // disabled={!editable || panDisable || panNumberDisable}
              validationState={panValidationAttempted}
              validateThirdPartyAttemptsFlag={validateThirdPartyAttemptsFlag}
            />
            {editable === true && (
              <Button
                style={{
                  height: "40px",
                  width: "75px",
                  position: "absolute",
                  right: 0,
                  top: 0,
                  margin: 0,
                }}
                size="small"
                disabled={
                  (!enabledReKycForDocumentVerification && panVerified) ||
                  panApplicantNumber === "" ||
                  typeof panApplicantNumber === "undefined" ||
                  panApplicantNumber === null || aadharApplicantName === ""
                  || dateOfBirth === null || dateOfBirth === "NAN" || panApplicantNumber?.length < 10 || typeof dateOfBirth === "undefined"
                }
                onClick={() => SearchProfileData(panApplicantNumber, "PAN")}
                className={classes.nextButton1}
              >
                verify
              </Button>
            )}
            {enabledUploadForm60Options && (
              <div
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "5px",
                  fontWeight: 500,
                }}
              >
               Please note: You must upload Form 60 at the next stage if the loan amount is less than {formatAmount(loanAmountForFrom60)}.
              </div>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Applicant Name"
              required
              id="applicant_name"
              value={panApplicantName}
              setState={setPanApplicantName}
              disabled={panVerifiedName}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
          <label style={{ display:"flex", alignItems:'center', color:'black', gap:'20px', fontSize:'16x' }}> 
                        <input
                          style={{ marginTop: 2, width:'30px', height:'30px' }}
                          type="checkbox"
                          // className={classTable.checkboxInput}
                          // checked={groupDetails[i].packetSealed}
                          value= {digilance}
                          name="Profiling"
                          onChange={(e) => checkedDueDigilance(e)}
                          disabled={!editable}
                          checked={digilance}
                        />
                     Profiling</label>
                      </Grid>
        {digilance && <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            {status === loanStatusNames?.inProcess || status === loanStatusNames?.aadhaar ? <CustomeSelectNew
              label="Profiling*"
              id="digilance"
              value={digilanceState}
              setState={setDigilanceState}
              error={dueDigilance}
              setError={setDueDigilance}
              type="name"
              data={digilanceData}
              disabled={!editable || loanStatus}
            /> : 
            <CustomeTextField
            label="Profiling"
              id="digilance"
              required
            value={digilanceState}
            disabled
            />
            }
          </Grid>}
          <Grid item xs={12} sm={12} md={12} className={classes.addressContainer}>
         <Grid
        item
        xs={12}
        sm={7}
        md={6}
      >
        <h2 className={classes.header}>Correspondence Address</h2>
      </Grid>
      <Grid
        item
        xs={12}
        sm={5}
        md={6}
        className={classes.inputFieldContainer}
        style={{marginTop:"15px",marginLeft:"0px"}}
      > <label>
      <input
        type="checkbox"
        value={sameAddress}
        onChange={(e) => checkedAddress(e)}
        checked={sameAddress || loanStatus ? true : false }
        disabled={!editable || loanStatus}
      />
      same as permanent address
    </label></Grid>
          </Grid></Grid></Grid>
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
            <CorrespondenceAddress
              sameAddress={sameAddress}
              disabledFields={disabledFields}
              houseCorrNumberState={houseCorrNumberState}
              streetCorrState={streetCorrState}
              localityCorrState={localityCorrState}
              postOfficeCorrState={postOfficeCorrState}
              villageTownCityCorrState={villageTownCityCorrState}
              districtCorrState={districtCorrState}
              pincodeCorrState={pincodeCorrState}
              stateNameCorrState={stateNameCorrState}
              setHouseCorrNumberState={setHouseCorrNumberState}
              setDistrictCorrState={setDistrictCorrState}
              setVillageTownCityCorrState={setVillageTownCityCorrState}
              setStateNameCorrState={setStateNameCorrState}
              setPostOfficeCorrState={setPostOfficeCorrState}
              setLocalityCorrState={setLocalityCorrState}
              setStreetCorrState={setStreetCorrState}
              setPincodeCorrState={setPincodeCorrState}
              houseNumber={houseNumber}
              editable={editable}
              street={street}
              locality={locality}
              postOffice={postOffice}
              villageTownCity={villageTownCity}
              stateName={stateName}
              stateList={stateList}
              district={district}
              pincode={pincode}
              classes={classes}
              coresHouseNumber={coresHouseNumber}
              setCoresHouseNumber={setCoresHouseNumber}
              coresLocality={coresLocality}
              setCoresLocality={setCoresLocality}
              coresStreet={coresStreet}
              setCoresStreet={setCoresStreet}
              coresPostOffice={coresPostOffice}
              setCoresPostOffice={setCoresPostOffice}
              coresVillage={coresVillage}
              setCoresVillage={setCoresVillage}
              coresDistrict={coresDistrict}
              setCoresDistrict={setCoresDistrict}
              coresPinCode={coresPinCode}
              setCoresPinCode={handleCorspinCode}
              coresState={coresState}
              setCoresState={setCoresState}
              loanStatus={loanStatus}
            />

          {status === loanStatusNames?.inProcess || status === loanStatusNames?.aadhaar || status === loanStatusNames?.selfie ? (
            <GridContainer>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                style={{
                  textAlign: window.innerWidth < 360 ? "center" : "right",
                  marginTop:"5%"
                }}
              >
                {!firstTab && <Button
                  // style={{ margin: "5px" }}
                  size="small"
                  className={classes.nextButton1}
                  // className="bg-gradient-theme-left border-0"
                  onClick={() => handlecancelapplicant()}
                >
                  Back
                </Button>}

                <Button
                  className={classes.nextButton}
                  size="small"
                  // color="info"
                  disabled={callInProgress || loanStatus || riskPresent || isKYCEntered}
                  onClick={(event) => handlecreateapplicantSubmit(event)}
                >
                  Next
                </Button>
              </GridItem>
            </GridContainer>
          ) : (
            <GridContainer>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                style={{
                  textAlign: window.innerWidth < 360 ? "center" : "right",
                  marginTop:"5%"
                }}
              >
                <Button
                  size="small"
                  className={classes.nextButton1}
                  disabled={callInProgress}
                  onClick={() => back()}
                >
                  Back
                </Button>
                <Button
                  size="small"
                  className={classes.nextButton}
                  disabled={callInProgress || loanStatus}
                  onClick={() => handlenext()}
                >
                  Next
                </Button>
              </GridItem>
            </GridContainer>
          )}
        </GridItem>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
            setShowModal={setShowModal}
            modalrepOpen={modalrepOpen}
            setModalReOpen={setModalReOpen}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
        {aadhaarPollingLoading && (
          <CircularProgresss callInProgress={aadhaarPollingLoading} text="Customer authentication is in process"/>
        )}
        {showModal && (
          <OtpModal
            handleClose={handleClose}
            showModal={showModal}
            Otp={verifyOtp}
            ResendOtp={sendEMailOtp}
          />
        )}

        {aadharOtpModal && (
          <OtpModal
            handleClose={handleAadharModalClose}
            showModal={aadharOtpModal}
            Otp={verifyAadharOtp}
            noResendOtp
          />
        )}
         {showAadharCaptureModal && (
            <AadharPhotoCaptureModal
              showModal={showAadharCaptureModal}
              closeModal={closeAadharCaptureModal}
              classesChild={classes}
              loanApplicationId={loanApplicationId}
              editable={editable}
              handleSave = {handleAadharCaptureData}
              singlePhtotAdhaarOcr={singlePhtotAdhaarOcr}
              featureFlags={featureFlags}
            />
          )}
           {confirmationModal && (
            <ConfirmationModal
              confirmationModal={confirmationModal}
              confirmationModalHeader={confirmationModalHeader}
              confirmationModalMsg={confirmationModalMsg}
              handleNegativeButton={handleNegativeResponse}
              handlePositiveButton={handlePositiveResponse}
              classes={classes}
            />
          )}
           {confirmationModalDigiloker && (
            <ConfirmationModal
              confirmationModal={confirmationModalDigiloker}
              confirmationModalHeader={confirmationModalHeaderDigiloker}
              confirmationModalMsg={confirmationModalMsgDigiloker}
              handleNegativeButton={() => setConfirmationModalDigiloker(false)}
            >
              <Button
                round
                className={classes.nextButton1}
                onClick={() => {
                  setConfirmationModalDigiloker(false);
                  setAadharIntegrationName(ocrVendor);
                  setShowAadharCaptureModal(true);
                }}
              >
                OCR
              </Button>
            </ConfirmationModal>
          )}
      </GridContainer>
    </div>
  );
};

ApplicantNew.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.object,
};

export default withStyles(styles)(ApplicantNew);